<!-- Copyright (c) 2023 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div>
    <div class="bank-recon-main">
      <div class="left-container" :class="[closeLeftTab ? 'left-tab-close' : '']">
        <div class="left-arrow-button">
          <img
            :style="{
              transform: `${
                closeLeftTab ? `scaleX(-1)`
                : !closeLeftTab ? `scaleX(1)`
                : closeLeftTab ? `rotate(90deg) scaleX(-1)`
                : `rotate(90deg) scaleX(1)`
              }`,
            }"
            @click="closeLeftTab = !closeLeftTab"
            src="https://dsmlib.logistics.systems/Icons/double-left.png"
          />
        </div>
        <div class="left-container-content" :style="{ display: closeLeftTab ? 'none' : '' }">
          <div class="left-container-content-button">
            <button
              :style="{ display: newDisabled ? 'none' : '' }"
              @click="newCancelClick('New')"
              :disabled="newDisabled"
              >New</button
            >
            <button
              :style="{ display: cancelDisabled ? 'none' : '' }"
              @click="newCancelClick('Cancel')"
              :disabled="cancelDisabled"
              >Cancel</button
            >
          </div>
          <Dropdown
            class="left-container-content-det"
            placeholder="Bank Code"
            :items="bankList"
            itemKey="banknamecurrency"
            :selectedObject.sync="selectedBank"
            :errorMessage.sync="bankError"
            @selected="bankCodeChange"
            :isRequired="true"
          />
          <DateTimePicker
            class="left-container-content-det"
            placeholder="Statement Date"
            :value.sync="selectedStatementDate"
            :showTime="false"
            :isDisabled="statementDateDisabled"
            @dateChanged="statementDateChange"
            :isRequired="statementDateRequired"
            :errorMessage.sync="selectedStatementDateError"
          />
          <Dropdown
            class="left-container-content-det"
            placeholder="Statement Name"
            :items="statementNameList"
            itemKey="Statement"
            :selectedObject.sync="selectedStatementName"
            @selected="statementNameChange"
            :isRequired="!statementNameDisabled"
            :errorMessage.sync="statementNameError"
            :allowFreeText="true"
            :search.sync="selectedStatementNameFreeText"
            :isDisabled="statementNameDisabled"
          />
          <CheckBoxV2
            v-if="showAllBSDisabled"
            title="Show All Bank Statement"
            :isChecked.sync="showAllBSCheck"
            @checkBoxClicked="showAllBSCheckClick"
          />
          <!-- <Input class="left-container-content-det" placeholder="Bank Description" :inputValue.sync="bankDescription" :isDisabled="true" />
          <Input class="left-container-content-det" placeholder="Bank Currency" :inputValue.sync="bankCurrency" :isDisabled="true" /> -->

          <BoxContainer title="GL Journal - Unreconciled" v-if="!refreshDisabled">
            <BoxContainer
              title="As At"
              :isCheckBox="true"
              :isChecked.sync="asAtCheck"
              @checkBoxClicked="outstandingCheckClick"
            >
              <div>
                <DateTimePicker
                  placeholder="As At"
                  :isDisabled="!asAtCheck"
                  :showTime="false"
                  :value.sync="selectedAsAtDate"
                  :errorMessage.sync="asAtError"
                  :isRequired="asAtRequired"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                />
              </div>
            </BoxContainer>
            <BoxContainer
              title="Transaction Within"
              :isCheckBox="true"
              :isChecked.sync="transactionWithinCheck"
              @checkBoxClicked="outstandingCheckClick"
            >
              <div>
                <DateTimePicker
                  placeholder="Start"
                  :isDisabled="!transactionWithinCheck"
                  :showTime="false"
                  :value.sync="selectedTransactionStartDate"
                  :errorMessage.sync="transactionStartError"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                />
                <DateTimePicker
                  placeholder="End"
                  :isDisabled="!transactionWithinCheck"
                  :showTime="false"
                  :value.sync="selectedTransactionEndDate"
                  :errorMessage.sync="transactionEndError"
                  :isRequired="transactionWithinRequired"
                  :maxDate="smallDateTimeMaxDate"
                  :minDate="smallDateTimeMinValue"
                />
              </div>
            </BoxContainer>
          </BoxContainer>

          <BoxContainer title="Month End">
            <div class="BC-MonthEnd">
              <div
                v-for="(n, i) in companyBranch"
                :key="i"
                class="BC-Branch"
                :style="{ backgroundColor: n['backgroundcolor'] }"
              >
                <div class="BC-Branch-Name">{{ n['Branch Name'] }}{{n['Department Name'] ? '-' : ''}}{{ n['Department Name'] }}</div>
                <div class="BC-Branch-Tooltip"
                  ><Tooltip class="BC-tooltipText" position="right" :tooltipText.sync="n['tooltiptext']"
                /></div>
              </div>
            </div>
          </BoxContainer>

          <div class="left-container-content-refresh">
            <button @click="refreshClicked" :disabled="refreshDisabled">Refresh</button>
          </div>
          <div class="left-container-content-refresh">
            <button @click="printClicked" :disabled="refreshDisabled">Print</button>
          </div>
        </div>
      </div>
      <div class="right-container" :class="[closeLeftTab ? 'right-tab-full' : '']">
        <div class="right-body">
          <div class="right-body-top">
            <div class="right-body-left">
              <div class="right-body-left-button">
                <button @click="UploadButtonClick">Upload</button>
              </div>
              <div class="right-body-left-table">
                <TableBox
                  title="Bank Statement"
                  :tableData.sync="bankStatementDataFilter"
                  :selectedRow.sync="selectedBankStatement"
                  :columnWidth="bankStatementColumnWidth"
                  :rowHeight="20"
                  :maxSelection="-1"
                  :hideColumns="bankStatementHideColumns"
                  :dataType="{ 'Txn Date': 'date', 'Debit Amt': 'currency', 'Credit Amt': 'currency' }"
                />
              </div>
            </div>
            <div class="right-body-middle">
              <div class="right-body-middle-button">
                <button title="Reconciled" @click="reconFunction('RM')">
                  R
                  <img style="height: 10px" src="https://dsmlib.logistics.systems/Icons/icons8-down-arrow-26.png" />
                </button>
                <button title="Unreconciled" style="margin-bottom: 5px; margin-top: 130px" @click="reconFunction('U')">
                  <img style="height: 10px" src="https://dsmlib.logistics.systems/Icons/icons8-up-arrow-26.png" />
                  U
                </button>
              </div>
            </div>
            <div class="right-body-right">
              <div class="right-body-right-button">
                <button :disabled="disabledAutoMatch" @click="autoMatchClick">Auto-Match</button>
              </div>
              <div class="right-body-right-table">
                <TableBox
                  title="GL Journal - Unreconciled"
                  :tableData="unreconcileData"
                  :selectedRow.sync="selectedUnreconcileData"
                  :columnWidth="unreconcileColumnWidth"
                  :rowHeight="20"
                  :maxSelection="-1"
                  :hideColumns="unreconcileHideColumns"
                  :dataType="{ Date: 'date', Amount: 'currency', 'Bank Charges': 'currency' }"
                />
              </div>
            </div>
          </div>
          <div class="right-body-bottom">
            <div class="right-bottom-table" :style="{ display: closeReconTab ? 'none' : '' }">
              <TableBox
                v-if="showReconcileData"
                title="GL Journal - Reconciled"
                :tableData="reconcileData"
                :selectedRow.sync="selectedReconcileData"
                :columnWidth="reconcileColumnWidth"
                :rowHeight="20"
                :maxSelection="-1"
                :hideColumns="reconcileHideColumns"
                :dataType="{
                  Date: 'date',
                  Amount: 'currency',
                  'Bank Stmt Amt': 'currency',
                  'Amount vs Bank Stmt Amt': 'currency',
                }"
              />
            </div>
          </div>
        </div>
        <div class="right-bottom">
          <div class="right-bottom-content">
            <div>
              <Input
                placeholder="Balance B/F"
                :inputValue="`${currencyFormattedValue('balanceBF')}`"
                textType="text"
                :isDisabled="true"
              />
            </div>
            <div>
              <Input
                placeholder="Total Debit"
                :inputValue="`${currencyFormattedValue('totalDebit')}`"
                textType="text"
                :isDisabled="true"
              />
            </div>
            <div>
              <Input
                placeholder="Total Credit"
                :inputValue="`${currencyFormattedValue('totalCredit')}`"
                textType="text"
                :isDisabled="true"
              />
            </div>
            <div>
              <Input
                placeholder="Balance C/F"
                :inputValue="`${currencyFormattedValue('balanceCF')}`"
                textType="text"
                :isDisabled="true"
              />
            </div>
          </div>
          <div class="right-bottom-button">
            <button @click="saveClick">
              <img src="https://dsmlib.logistics.systems/Icons/Save.png" />
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showImportBankStatement" class="bank-recon-upload">
      <div class="top-container">
        <div class="top-container-content">
          <div style="width: 300px"
            ><Dropdown
              placeholder="Template"
              :items="uploadTemplate"
              itemKey="Template"
              :selectedObject.sync="selectedTemplate"
              :isRequired="true"
          /></div>
          <div style="width: 200px"
            ><Input
              placeholder="Statement Name"
              textType="text"
              validator="text,50"
              :inputValue.sync="statementNameUpload"
              :isRequired="true"
              :isDisabled="true"
          /></div>
          <div style="width: 300px"
            ><DateTimePicker
              placeholder="Statement Date"
              :showTime="false"
              :value.sync="statementDateUpload"
              :isRequired="true"
              :isDisabled="true"
          /></div>
          <div style="width: 300px"
            ><Dropdown
              placeholder="Bank"
              :items="bankList"
              itemKey="BankName"
              :selectedObject.sync="selectedBank"
              :isRequired="true"
              :isDisabled="true"
          /></div>
          <div style="width: 200px"
            ><Input
              placeholder="Opening Balance"
              textType="text"
              validator="decimal,14,2"
              :inputValue.sync="openBalance"
              :isRequired="true"
              :errorMessage.sync="openBalanceError"
          /></div>
        </div>
        <div class="top-container-file">
          <div class="file-input">
            <Input
              class="fileInput"
              placeholder="Select File"
              textType="file"
              :isDisabled="fileDisabled"
              @fileChanged="fileChanged"
            />
          </div>
          <div class="file-button">
            <button :disabled="statementSaveDisabled" @click="saveStatementList">Save</button>
            <button @click="uploadCancelClick">Cancel</button>
          </div>
          <div class="message-container" :style="messageBoxStyle" v-html="messageBoxText"></div>
        </div>
      </div>
      <div class="body">
        <TableBox
          title="Bank Statement Transaction"
          :tableData="exportedData"
          :dataType="uploadedColumnDataType"
          :hideColumns="['Txn Time']"
        />
      </div>
    </div>
    <div v-if="showMatchPopUp" class="bank-recon-match">
      <div class="bank-recon-match-container">
        <div class="top-container">
          <div class="top-container-checkbox">
            <div class="checkbox-one">
              <CheckBoxV2
                title="Show me matching Cheque #"
                :isChecked.sync="rules1Check"
                @checkBoxClicked="rules1CheckBoxChange"
              />
              <CheckBoxV2
                title="Show me matching Amount"
                :isChecked.sync="rules1AmountCheck"
                @checkBoxClicked="rules1CheckBoxChange"
              />
              <CheckBoxV2
                title="Show me matching Date"
                :isChecked.sync="rules1DateCheck"
                @checkBoxClicked="rules1CheckBoxChange"
              />
            </div>
            <CheckBoxV2
              title="Show me matching Bank Statement column vs GL Journal column"
              @checkBoxClicked="rules2CheckboxChange"
              :isChecked.sync="rules2Check"
            />
            <div class="top-container-dropdown" :style="{ display: hideRules2Dropdown ? 'none' : '' }">
              <Dropdown
                placeholder="Bank Statement Column"
                :items="bankStatementDataColumn"
                itemKey="columnname"
                :selectedObject.sync="selectedBankStatementDataColumn"
                :errorMessage.sync="selectedBankStatementColumnError"
              />
              <Dropdown
                placeholder="GL Journal Column"
                :items="unreconcileDataColumn"
                itemKey="columnname"
                :selectedObject.sync="selectedUnreconcilleDataColumn"
                :errorMessage.sync="selectedUnreconcilleColumnError"
              />
            </div>
          </div>
          <div class="top-container-button">
            <button @click="matchClick">Match</button>
          </div>
          <div class="top-container-match-text">
            {{ matchSelectedText }}
          </div>
          <div class="top-container-info">
            Bank Statement Transaction Uploaded : {{ bankStatementData.length }}<br />
            Unreconciled Transaction : {{ unreconcileData.length }}<br />
            Auto Match : {{ autoMatchData.length }}
          </div>
        </div>
        <div class="body">
          <TableBox
            title="Auto Matching"
            :tableData="autoMatchData"
            :maxSelection="-1"
            :selectedRow.sync="selectedAutoMatch"
            :showSelectAll="autoMatchData.length > 0"
            :hideColumns="autoMatchHideColumns"
            :columnWidth="autoMatchColumnWidth"
            :rowHeight="20"
            :dataType="{
              'St Txn Date': 'date',
              'St Debit Amt': 'currency',
              'St Credit Amt': 'currency',
              'Gl Date': 'date',
              'Gl Amount': 'currency',
            }"
          />
        </div>
        <div class="bottom-container">
          <div class="bottom-container-button">
            <button @click="reconFunction('RA')">Confirm</button>
            <button @click="showMatchPopUp = !showMatchPopUp">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    //upload bank statement computed
    fileDisabled: function () {
      if (this.selectedTemplate?.['Template'] == 'None') {
        //Select Not to upload file
        return true;
      }
      const disabled =
        !this.selectedTemplate ||
        this.statementNameUpload == '' ||
        !this.statementDateUpload ||
        !this.selectedBank ||
        this.openBalance == '';
      return disabled;
    },

    statementSaveDisabled: function () {
      if (this.selectedTemplate?.['Template'] == 'None' && this.openBalance) {
        return false;
      }
      const disabled = this.fileDisabled || !this.selectedFile || this.exportedData.length == 0;
      return disabled;
    },

    messageBoxStyle: function () {
      if (this.messageBoxType == 'success') {
        return {
          backgroundColor: 'rgba(50, 205, 50, 0.4)',
        };
      } else if (this.messageBoxType == 'error') {
        return {
          backgroundColor: 'rgba(205, 92, 92, 0.4)',
        };
      }
      return {
        backgroundColor: 'rgba(255, 246, 121, 0.4)',
      };
    },

    bankStatementColumnWidth: function () {
      if (!this.bankStatementData || this.bankStatementData.length === 0) {
        return [];
      }

      const arrayColumns = Object.keys(this.bankStatementData[0]).filter(
        (f) => !this.bankStatementHideColumns.includes(f),
      );
      const numberOfColumns = arrayColumns.length;
      const result = Array.from({ length: numberOfColumns }, () => 180);

      const chqIndex = arrayColumns.indexOf('Chq #');
      const txnDateIndex = arrayColumns.indexOf('Txn Date');
      const debitAmtIndex = arrayColumns.indexOf('Debit Amt');
      const creditAmtIndex = arrayColumns.indexOf('Credit Amt');
      result[chqIndex] = 80;
      result[txnDateIndex] = 100;
      result[debitAmtIndex] = 110;
      result[creditAmtIndex] = 110;

      return result;
    },

    unreconcileColumnWidth: function () {
      if (!this.unreconcileData || this.unreconcileData.length === 0) {
        return [];
      }

      const arrayColumns = Object.keys(this.unreconcileData[0]).filter((f) => !this.unreconcileHideColumns.includes(f));
      const numberOfColumns = arrayColumns.length;
      const result = Array.from({ length: numberOfColumns }, () => 180);

      const chqIndex = arrayColumns.indexOf('Chq #');
      const dateInedx = arrayColumns.indexOf('Date');
      const typeIndex = arrayColumns.indexOf('Type');
      const txnIndex = arrayColumns.indexOf('Txn');
      const receiptIndex = arrayColumns.indexOf('Receipt #');
      const amountIndex = arrayColumns.indexOf('Amount');
      const bankChargesIndex = arrayColumns.indexOf('Bank Charges');
      const currencyIndex = arrayColumns.indexOf('Currency');
      const rateIndex = arrayColumns.indexOf('Rate');

      result[chqIndex] = 80;
      result[dateInedx] = 100;
      result[typeIndex] = 70;
      result[txnIndex] = 70;
      result[receiptIndex] = 100;
      result[amountIndex] = 110;
      result[bankChargesIndex] = 120;
      result[currencyIndex] = 90;
      result[rateIndex] = 70;

      return result;
    },

    reconcileColumnWidth: function () {
      if (!this.reconcileData || this.reconcileData.length === 0) {
        return [];
      }

      const arrayColumns = Object.keys(this.reconcileData[0]).filter((f) => !this.reconcileHideColumns.includes(f));
      const numberOfColumns = arrayColumns.length;
      const result = Array.from({ length: numberOfColumns }, () => 180);

      const chqIndex = arrayColumns.indexOf('Chq #');
      const dateInedx = arrayColumns.indexOf('Date');
      const typeIndex = arrayColumns.indexOf('Type');
      const txnIndex = arrayColumns.indexOf('Txn');
      const receiptIndex = arrayColumns.indexOf('Receipt #');
      const amountIndex = arrayColumns.indexOf('Amount');
      const currencyIndex = arrayColumns.indexOf('Currency');
      const rateIndex = arrayColumns.indexOf('Rate');
      const bankStmtAmtIndex = arrayColumns.indexOf('Bank Stmt Amt');
      const amountVsBankStmtAmt = arrayColumns.indexOf('Amount vs Bank Stmt Amt');

      result[chqIndex] = 100;
      result[dateInedx] = 120;
      result[typeIndex] = 70;
      result[txnIndex] = 70;
      result[receiptIndex] = 120;
      result[amountIndex] = 120;
      result[currencyIndex] = 90;
      result[rateIndex] = 70;
      result[bankStmtAmtIndex] = 120;
      result[amountVsBankStmtAmt] = 200;

      return result;
    },

    autoMatchColumnWidth: function () {
      if (!this.autoMatchData || this.autoMatchData.length === 0) {
        return [];
      }

      const arrayColumns = Object.keys(this.autoMatchData[0]).filter((f) => !this.autoMatchHideColumns.includes(f));
      const numberOfColumns = arrayColumns.length;
      const result = Array.from({ length: numberOfColumns }, () => 180);

      const stChqIndex = arrayColumns.indexOf('St Chq #');
      const stTxnDateIndex = arrayColumns.indexOf('St Txn Date');
      const stDebitIndex = arrayColumns.indexOf('St Debit Amt');
      const stCreditIndex = arrayColumns.indexOf('St Credit Amt');
      const glChqIndex = arrayColumns.indexOf('Gl Chq #');
      const glDateIndex = arrayColumns.indexOf('Gl Date');
      const glTypeIndex = arrayColumns.indexOf('Gl Type');
      const glTxnIndex = arrayColumns.indexOf('Gl Txn');
      const glReceiptIndex = arrayColumns.indexOf('Gl Receipt');
      const glAmountIndex = arrayColumns.indexOf('Gl Amount');

      result[stChqIndex] = 90;
      result[stTxnDateIndex] = 110;
      result[stDebitIndex] = 130;
      result[stCreditIndex] = 130;
      result[glChqIndex] = 90;
      result[glDateIndex] = 100;
      result[glTypeIndex] = 80;
      result[glTxnIndex] = 80;
      result[glReceiptIndex] = 100;
      result[glAmountIndex] = 110;

      return result;
    },
  },
  data: function () {
    return {
      loginDetails: null,
      smallDateTimeMinValue: new Date(2000, 0, 1),
      smallDateTimeMaxDate: new Date(2079, 0, 1),
      //main bank recon variables start
      closeLeftTab: false,
      closeRulesTab: false,
      closeReconTab: false,
      reconciliationList: [{ Type: 'Bank' }],
      selectedReconType: null,
      newDisabled: false,
      cancelDisabled: true,
      refreshDisabled: false,
      bankList: [],
      selectedBank: null,
      bankError: '',
      statementDateDisabled: true,
      statementDateRequired: false,
      selectedStatementDate: null,
      selectedStatementDateError: '',
      statementNameList: [],
      statementNameDisabled: false,
      selectedStatementName: null,
      statementNameError: '',
      selectedStatementNameFreeText: '',
      showAllBSCheck: false,
      asAtCheck: false,
      asAtRequired: false,
      selectedAsAtDate: null,
      asAtError: '',
      transactionWithinCheck: true,
      transactionWithinRequired: true,
      selectedTransactionStartDate: null,
      transactionStartError: '',
      selectedTransactionEndDate: null,
      transactionEndError: '',
      selectedBranch: null,
      bankDescription: '',
      bankCurrency: '',
      companyBranch: [],
      blockCompanyBranch: [],
      disabledUpload: true,
      openBalanceError: '',
      showAllBSDisabled: false, // disabled "Show All Bank Statement" - for development use only
      allowReconWithoutBankStatement: false, //allow reconcile without selecting bank statement

      bankStatementData: [],
      bankStatementDataFilter: [],
      bankStatementHideColumns: [
        'TxnID',
        'MatchTxnID',
        'ParentTxnID',
        'Opening Bal',
        'Closing Bal',
        'Seq',
        'Original',
        'action',
        'matched',
      ],
      selectedBankStatement: [],
      bankStatementDataColumn: [],
      selectedBankStatementDataColumn: null,
      selectedBankStatementColumnError: '',
      unreconcileData: [],
      unreconcileHideColumns: [
        'HeaderTxnID',
        'CoCode',
        'Statement Name',
        'Seq',
        'Original',
        'action',
        'TxnID',
        'ParentTxnID',
      ],
      selectedUnreconcileData: [],
      unreconcileDataColumn: [],
      selectedUnreconcilleDataColumn: null,
      selectedUnreconcilleColumnError: '',
      reconcileData: [],
      reconcileHideColumns: [
        'HeaderTxnID',
        'CoCode',
        'Statement Name',
        'Statement Date',
        'Seq',
        'Original',
        'action',
        'TxnID',
        'ParentTxnID',
        'Temp',
      ],
      selectedReconcileData: [],
      showReconcileData: true,

      balanceBF: '0',
      totalDebit: '0',
      totalCredit: '0',
      balanceCF: '0',

      changesMade: false,
      originalStatementName: '',

      //refresh Original Value
      refreshBankCode: null,
      refreshStatementDate: null,
      refreshStatementName: '',
      //end

      showImportBankStatement: false,
      //upload bank statment variables start
      uploadTemplate: [
        {
          Template: 'DSM(Transaction)',
        },
        {
          Template: 'DSM(Statement)',
        },
        {
          Template: 'Hong Leong Bank(Transaction)',
        },
        {
          Template: 'Hong Leong Bank(Statement)',
        },
        {
          Template: 'CIMB Bank',
        },
        {
          Template: 'Alliance Bank',
        },
        {
          Template: 'AmBank',
        },
        {
          Template: 'Maybank(Transaction)',
        },
        {
          Template: 'UOB(Transaction)',
        },
        {
          Template: 'None',
        },
      ],
      columnMapping: [
        {
          Template: 'AmBank',
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Posting Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Transaction Details'],
            },
            {
              name: 'Cheque No',
              possibleValues: ['Cheque No'],
            },
            {
              name: 'Party Name',
              possibleValues: [],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Customer Ref. No.'],
            },
            {
              name: 'Payment Details',
              possibleValues: ['Transaction Ref No'],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: ['Debit'],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: ['Credit'],
            },
            {
              name: 'Balance',
              possibleValues: ['Running Balance'],
            },
            {
              name: 'Branch Code',
              possibleValues: [],
            },
          ],
        },
        {
          Template: 'Alliance Bank',
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Transaction Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Transaction Description'],
            },
            {
              name: 'Cheque No',
              possibleValues: ['Cheque No'],
            },
            {
              name: 'Party Name',
              possibleValues: [],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Reference 1'],
            },
            {
              name: 'Payment Details',
              possibleValues: ["Recipient's Reference / Other Payment Details"],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: ['Debit'],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: ['Credit'],
            },
            {
              name: 'Balance',
              possibleValues: ['Balance'],
            },
            {
              name: 'Branch Code',
              possibleValues: ['Branch Name'],
            },
            {
              name: 'Reference 2',
              possibleValues: ['Reference 2'],
            },
          ],
        },
        {
          Template: 'CIMB Bank',
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Transaction Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Transaction Code Description'],
            },
            {
              name: 'Cheque No',
              possibleValues: [],
            },
            {
              name: 'Party Name',
              possibleValues: [],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Document Reference Number'],
            },
            {
              name: 'Payment Details',
              possibleValues: [],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: ['Transaction Amount'],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: ['Transaction Amount'],
            },
            {
              name: 'Balance',
              possibleValues: ['Balance'],
            },
            {
              name: 'Branch Code',
              possibleValues: ['Originating Branch Code'],
            },
            {
              name: 'Transaction Amount Type', //C or D, D then Transaction Amount go to Debit only, C then opposite
              possibleValues: ['Transaction Amount Type'],
            },
          ],
        },
        {
          Template: 'DSM(Transaction)', //follow hong leong transaction
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Transaction Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Remarks'],
            },
            {
              name: 'Cheque No',
              possibleValues: ['Cheque No.'],
            },
            {
              name: 'Party Name',
              possibleValues: ['Sender / Receiver Name'],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Recipient Reference'],
            },
            {
              name: 'Payment Details',
              possibleValues: ['Other Payment Details'],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: ['Payment Amount'],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: ['Credit Amount'],
            },
            {
              name: 'Balance',
              possibleValues: ['Balance'],
            },
            {
              name: 'Branch Code',
              possibleValues: ['Branch Code'],
            },
          ],
        },
        {
          Template: 'DSM(Statement)', //follow hong leong statement
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Transaction Description'],
            },
            {
              name: 'Cheque No',
              possibleValues: ['Cheque No.'],
            },
            {
              name: 'Party Name',
              possibleValues: ['Sender / Receiver Name'],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Ref. No.'],
            },
            {
              name: 'Payment Details',
              possibleValues: [''],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: ['Withdrawal'],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: ['Deposit'],
            },
            {
              name: 'Balance',
              possibleValues: ['Balance'],
            },
            {
              name: 'Branch Code',
              possibleValues: [''],
            },
          ],
        },
        {
          Template: 'Hong Leong Bank(Transaction)',
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Transaction Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Remarks'],
            },
            {
              name: 'Cheque No',
              possibleValues: ['Cheque No.'],
            },
            {
              name: 'Party Name',
              possibleValues: ['Sender / Receiver Name'],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Recipient Reference'],
            },
            {
              name: 'Payment Details',
              possibleValues: ['Other Payment Details'],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: ['Payment Amount'],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: ['Credit Amount'],
            },
            {
              name: 'Balance',
              possibleValues: ['Balance'],
            },
            {
              name: 'Branch Code',
              possibleValues: ['Branch Code'],
            },
          ],
        },
        {
          Template: 'Hong Leong Bank(Statement)',
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Transaction Description'],
            },
            {
              name: 'Cheque No',
              possibleValues: ['Cheque No.'],
            },
            {
              name: 'Party Name',
              possibleValues: ['Sender / Receiver Name'],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Ref. No.'],
            },
            {
              name: 'Payment Details',
              possibleValues: [''],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: ['Withdrawal'],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: ['Deposit'],
            },
            {
              name: 'Balance',
              possibleValues: ['Balance'],
            },
            {
              name: 'Branch Code',
              possibleValues: [''],
            },
          ],
        },
        {
          Template: 'Maybank(Transaction)',
          map: [
            {
              name: 'Txn Date',
              possibleValues: ['Posting Date'],
            },
            {
              name: 'Remarks',
              possibleValues: ['Transaction Description 3'],
            },
            {
              name: 'Cheque No',
              possibleValues: ['Transaction Description 4'],
            },
            {
              name: 'Party Name',
              possibleValues: ['Transaction Description 2'],
            },
            {
              name: 'Recipient Reference',
              possibleValues: ['Transaction Ref'],
            },
            {
              name: 'Payment Details',
              possibleValues: [],
            },
            {
              name: 'Debit Amount',
              possibleValues: ['Debit'],
            },
            {
              name: 'Credit Amount',
              possibleValues: ['Credit'],
            },
            {
              name: 'Balance',
              possibleValues: [],
            },
            {
              name: 'Branch Code',
              possibleValues: [],
            },
            {
              name: 'Txn Time',
              possibleValues: ['Processing Time'], //this is a special case, time is in different column, will hide it in the tablebox
            },
          ],
        },
        {
          Template: 'UOB(Transaction)',
          map: [
            {
              name: 'Txn Date',
              possibleValues: [' Date '],
            },
            {
              name: 'Remarks',
              possibleValues: [' Remarks '],
            },
            {
              name: 'Cheque No',
              possibleValues: [' Cheque Number '],
            },
            {
              name: 'Party Name',
              possibleValues: [' Your Reference '],
            },
            {
              name: 'Recipient Reference',
              possibleValues: [],
            },
            {
              name: 'Payment Details',
              possibleValues: [],
            },
            {
              name: 'Debit Amount', //money out
              possibleValues: [' Withdrawal '],
            },
            {
              name: 'Credit Amount', //money in
              possibleValues: [' Deposit '],
            },
            {
              name: 'Balance',
              possibleValues: [],
            },
            {
              name: 'Branch Code',
              possibleValues: [],
            },
            {
              name: 'Txn Time',
              possibleValues: [' Time '], //this is a special case, time is in different column, will hide it in the tablebox
            },
          ],
        },
      ],
      possibleNAText: ['NA', 'N/A'],
      uploadedColumnDataType: {
        'Txn Date': 'datetime',
        'Debit Amount': 'currency',
        'Credit Amount': 'currency',
        Balance: 'currency',
      },
      selectedTemplate: null,
      statementNameUpload: '',
      statementDateUpload: null,
      lastMonthClosingBal: null,
      openBalance: '',
      closeBalance: '',
      messageBoxText: '',
      messageBoxType: '',

      exportedData: [],
      selectedFile: null,
      //end

      disabledAutoMatch: false,
      showMatchPopUp: false,
      rules1Check: false, //show me matching cheque # checkbox
      rules1AmountCheck: false, //Show me matching amount
      rules1DateCheck: false, //Show me matching date
      rules2Check: false, //show me matching bank statement column vs gl journal column checkbox
      hideRules2Dropdown: true, //hide the dropdown column
      matchSelectedText: 'No matches',
      bankStatementColumn: null,
      glJournalColumn: null,
      autoMatchData: [],
      autoMatchHideColumns: ['Rules', 'St Ref', 'St Det', 'St TxnId', 'GL HeaderTxnID'],
      selectedAutoMatch: [],
    };
  },
  props: {},
  methods: {
    bankCodeChange: function (e) {
      if (e) {
        this.selectedStatementName = null;
      }
    },
    statementDateChange: function (e) {
      if (e) {
        this.selectedStatementName = null;
      }
    },
    statementNameChange: function (e) {
      if (e) {
        //default based on selected statement name;
        this.selectedBank = this.bankList.getSelected(e['Bank'], 'BankCode');
        this.bankError = '';
        this.selectedStatementDate = new Date(e['Statement Date']);
        this.selectedStatementDateError = '';
        this.statementNameUpload = e['Statement'];
        this.statementNameError = '';
        this.transactionStartError = '';
        this.transactionEndError = '';
        this.disabledUpload = false;
      } else {
        this.disabledUpload = true;
        this.statementNameUpload = '';
      }
    },

    UploadButtonClick: async function () {
      if (!this.selectedStatementName && this.selectedStatementNameFreeText == '') {
        this.$showAlert('warning', 'No Statement Selected', 'Please select a statement name');
        return;
      }

      let lastMonthDate = new Date(this.selectedStatementDate);
      lastMonthDate = new Date(lastMonthDate.setMonth(lastMonthDate.getMonth() - 1));
      const result = await this.$apiCallV2('/BankReconciliation/GetBankStatementUpload', {
        statementname:
          this.selectedStatementName ? this.selectedStatementName['Statement'] : this.selectedStatementNameFreeText,
        getlastmonthbalcf: '1',
        bank: this.selectedBank['BankCode'],
        month: lastMonthDate.getMonth() + 1,
        year: lastMonthDate.getFullYear(),
      });

      if (result?.[0]?.['Closing Balance']) {
        this.lastMonthClosingBal = result[0]['Closing Balance'];
      } else {
        this.lastMonthClosingBal = null;
      }

      this.showImportBankStatement = true;
      this.statementDateUpload = this.selectedStatementDate ?? null;
      this.statementNameUpload = this.selectedStatementName?.['Statement'] ?? this.selectedStatementNameFreeText;
    },

    fileChanged: async function (files) {
      this.showMessage();

      if (files.length > 0) {
        this.selectedFile = files[0];
        this.exportedData = [];
        let exportJSON = await this.$excelToJson(files[0], false);
        // console.log('exportjson', exportJSON); //for testing

        if (exportJSON['success']) {
          let jsonData = exportJSON['data'];
          const columnMappingBank = this.columnMapping.find(
            (f) => f['Template'] == this.selectedTemplate['Template'],
          )?.['map'];
          columnMappingBank.forEach((d) => delete d['key']); //delete 'key' in object if there is
          // console.log(columnMappingBank); //for testing
          //to handle different template format...
          if (
            this.selectedTemplate['Template'] === 'Hong Leong Bank(Transaction)' ||
            this.selectedTemplate['Template'] === 'DSM(Transaction)'
          ) {
            // console.log('Hong Leong Bank enter'); //for testing
            const sheet = jsonData.find((j) => j['sheet'] == 'Sheet0');
            if (sheet) {
              // console.log('Hong Leong Bank Sheet Enter'); //for testing
              const sheetData = sheet['data'];
              //for sheetData, in the excel. the first row is not being read into the json.
              // The second row will be obj 0 in the Json Array(sheetData), follow by next row is obj 1

              const keys = Object.keys(sheetData[6]); //get the 7th obj key
              // console.log('keys', keys); //for testing
              const values = Object.values(sheetData[6]); //get the 7th obj values
              // console.log('values', values); //for testing

              values.forEach((v, i) => {
                const mapped = columnMappingBank.find((c) => c['possibleValues'].includes(v));
                // console.log('mapped', mapped); //for testing
                if (mapped) {
                  mapped['key'] = keys[i];
                  // console.log(mapped['key']); //for testing
                }
              });

              // console.log('columnMappingBank', columnMappingBank); //for testing
              let finalJson = sheetData.map((s) => {
                const obj = {};
                columnMappingBank.forEach((c) => {
                  obj[c['name']] = s[c['key']] ? s[c['key']] : '';
                });
                return obj;
              });

              finalJson.splice(0, 7);
              finalJson = finalJson.map((f, i) => {
                if (f['Txn Date']) {
                  const [date, time] = f['Txn Date'].split(' ');
                  const [day, month, year] = date.split('/');
                  const hours = time.slice(0, 2);
                  const minutes = time.slice(3, 5);

                  f['Txn Date'] = `${year}-${month}-${day} ${hours}:${minutes}`;
                }
                f['Debit Amount'] = this.checkNumberFromExcel(f['Debit Amount']);
                f['Credit Amount'] = this.checkNumberFromExcel(f['Credit Amount']);

                return { '#': ++i, ...f };
              });
              let closeBalanceSum = parseFloat(this.openBalance);
              finalJson.forEach((f) => {
                closeBalanceSum = closeBalanceSum - parseFloat(f['Debit Amount']) + parseFloat(f['Credit Amount']);
              });
              this.closeBalance = closeBalanceSum.toFixed(2);
              this.exportedData = finalJson;
              this.selectedFile = files[0];
            } else {
              this.showMessage(
                'error',
                'Cannot find the correct sheet within the excel file.\nPlease make sure the format is correct.',
              );
            }
          } else if (
            this.selectedTemplate['Template'] === 'Hong Leong Bank(Statement)' ||
            this.selectedTemplate['Template'] === 'DSM(Statement)'
          ) {
            // console.log('Hong Leong Bank enter'); //for testing
            const sheet = jsonData.find((j) => j['sheet'] == 'Sheet0');
            // console.log(sheet); //for testing
            if (sheet) {
              // console.log('Hong Leong Bank Sheet Enter'); //for testing
              const sheetData = sheet['data'];
              const keys = Object.keys(sheetData[0]); //get the 2nd obj key
              // console.log('keys', keys); //for testing
              const values = Object.values(sheetData[0]); //get the 2nd obj values
              // console.log('values', values); //for testing
              // if (!validateColumns(keys, requiredColumns)) {return;} // validate number of columns

              values.forEach((v, i) => {
                const mapped = columnMappingBank.find((c) => c['possibleValues'].includes(v));
                // console.log('mapped', mapped); //for testing
                if (mapped) {
                  mapped['key'] = keys[i];
                  // console.log(mapped['key']); //for testing
                }
              });

              // console.log('columnMappingBank', columnMappingBank); //for testing
              let finalJson = sheetData.map((s) => {
                const obj = {};
                columnMappingBank.forEach((c) => {
                  obj[c['name']] = s[c['key']] ? s[c['key']] : '';
                });
                return obj;
              });

              finalJson.splice(0, 2); //splice records so that it only shows from the first actual record
              finalJson = finalJson.map((f, i) => {
                if (f['Txn Date']) {
                  const [date, time] = f['Txn Date'].split(' ');
                  const [day, month, year] = date.split('/');
                  const hours = time?.slice(0, 2) ?? '00';
                  const minutes = time?.slice(3, 5) ?? '00';
                  f['Txn Date'] = `${year}-${month}-${day} ${hours}:${minutes}`;
                }
                f['Debit Amount'] = this.checkNumberFromExcel(f['Debit Amount']);
                f['Credit Amount'] = this.checkNumberFromExcel(f['Credit Amount']);

                return { '#': ++i, ...f };
              });
              let closeBalanceSum = parseFloat(this.openBalance);
              finalJson.forEach((f) => {
                closeBalanceSum = closeBalanceSum - parseFloat(f['Debit Amount']) + parseFloat(f['Credit Amount']);
              });
              this.closeBalance = closeBalanceSum.toFixed(2);
              this.exportedData = finalJson;
              this.selectedFile = files[0];
            } else {
              this.showMessage(
                'error',
                'Cannot find the correct sheet within the excel file.\nPlease make sure the format is correct.',
              );
            }
          } else if (this.selectedTemplate['Template'] === 'CIMB Bank') {
            exportJSON = await this.$excelToJson(files[0], true); //get all raw data since there is no date column in this template
            jsonData = exportJSON['data'];
            const sheet = jsonData.find((j) => j['sheet'] == 'Sheet0');
            if (sheet) {
              const sheetData = sheet['data'];
              const keys = Object.keys(sheetData[5]);
              const values = Object.values(sheetData[5]);
              values.forEach((v, i) => {
                const mapped = columnMappingBank.filter((c) => c['possibleValues'].includes(v)); //change to filter because 1 column might need to go to multiple mapping
                if (mapped.length > 0) {
                  mapped.forEach((m) => {
                    m['key'] = keys[i];
                  });
                }
              });
              let finalJson = sheetData.map((s) => {
                const obj = {};
                columnMappingBank.forEach((c) => {
                  obj[c['name']] = s[c['key']] ? s[c['key']] : '';
                });
                return obj;
              });

              finalJson.splice(0, 6);
              finalJson = finalJson.map((f, i) => {
                if (f['Txn Date']) {
                  let txnDateTemp = f['Txn Date'];
                  txnDateTemp = txnDateTemp.toString();
                  if (txnDateTemp.length < 8) {
                    //sometimes excel will remove the leading 0 so need to add back
                    txnDateTemp = `0${txnDateTemp}`;
                  }
                  const tempDate = txnDateTemp;
                  const day = tempDate.slice(0, 2);
                  const month = tempDate.slice(2, 4);
                  const year = tempDate.slice(4, 8);

                  f['Txn Date'] = `${year}-${month}-${day} 00:00`;
                }
                if (f['Transaction Amount Type'] == 'D') {
                  //D is Debit, Make Credit 0
                  f['Credit Amount'] = '0.00';
                } else if (f['Transaction Amount Type'] == 'C') {
                  //C is Credit, Make Debit 0
                  f['Debit Amount'] = '0.00';
                }

                return { '#': ++i, ...f };
              });
              let closeBalanceSum = parseFloat(this.openBalance);
              finalJson.forEach((f) => {
                closeBalanceSum = closeBalanceSum - parseFloat(f['Debit Amount']) + parseFloat(f['Credit Amount']);
              });
              this.closeBalance = closeBalanceSum.toFixed(2);
              this.exportedData = finalJson;
              this.selectedFile = files[0];
            } else {
              this.showMessage(
                'error',
                'Cannot find the correct sheet within the excel file.\nPlease make sure the format is correct.',
              );
            }
          } else if (this.selectedTemplate['Template'] == 'Alliance Bank') {
            const sheet = jsonData.find((j) => j['sheet'] == 'Sheet0');

            if (sheet) {
              const sheetData = sheet['data'];
              const keys = Object.keys(sheetData[2]); //this is to get the column row from excel. somtime empty row is not consider a row.
              const values = Object.values(sheetData[2]);

              values.forEach((v, i) => {
                const mapped = columnMappingBank.find((c) => c['possibleValues'].includes(v));
                if (mapped) {
                  mapped['key'] = keys[i];
                }
              });

              let finalJson = sheetData.map((s) => {
                const obj = {};
                columnMappingBank.forEach((c) => {
                  obj[c['name']] = s[c['key']] ? s[c['key']] : '';
                });
                return obj;
              });

              finalJson.splice(0, 3);
              finalJson = finalJson.map((f, i) => {
                if (f['Txn Date']) {
                  // eslint-disable-next-line prefer-const -- time need to be changed so remain as let
                  let [date, time] = f['Txn Date'].split(' ');
                  let [month, day, year] = date.split('/');
                  if (time && time.length == 4) {
                    time = `0${time}`;
                  }
                  if (year && year.length == 2) {
                    year = `20${year}`;
                  }
                  if (day && day.length == 1) {
                    day = `0${day}`;
                  }
                  if (month && month.length == 1) {
                    month = `0${month}`;
                  }
                  const hours = time?.slice(0, 2) ?? '00';
                  const minutes = time?.slice(3, 5) ?? '00';
                  f['Txn Date'] = `${year}-${month}-${day} ${hours}:${minutes}`;
                }
                if (f['Branch Code'] && f['Branch Code'].length > 10) {
                  f['Branch Code'] = f['Branch Code'].substring(0, 10);
                }
                if (f['Reference 2']) {
                  f['Recipient Reference'] = `${f['Recipient Reference']}; ${f['Reference 2']}`;
                }

                return { '#': ++i, ...f };
              });
              let closeBalanceSum = parseFloat(this.openBalance);
              finalJson.forEach((f) => {
                closeBalanceSum = closeBalanceSum - parseFloat(f['Debit Amount']) + parseFloat(f['Credit Amount']);
              });
              this.closeBalance = closeBalanceSum.toFixed(2);
              this.exportedData = finalJson;
              this.selectedFile = files[0];
            }
          } else if (this.selectedTemplate['Template'] == 'AmBank') {
            const sheet = jsonData.find((j) => j['sheet'] == 'Sheet0');

            if (sheet) {
              const sheetData = sheet['data'];
              const keys = Object.keys(sheetData[5]);
              const values = Object.values(sheetData[5]);

              values.forEach((v, i) => {
                const mapped = columnMappingBank.find((c) => c['possibleValues'].includes(v));
                if (mapped) {
                  mapped['key'] = keys[i];
                }
              });

              let finalJson = sheetData.map((s) => {
                const obj = {};
                columnMappingBank.forEach((c) => {
                  obj[c['name']] = s[c['key']] ? s[c['key']] : '';
                });
                return obj;
              });

              finalJson.splice(0, 6);
              finalJson = finalJson.map((f, i) => {
                if (f['Txn Date']) {
                  const [date, time] = f['Txn Date'].split(' ');
                  const [day, month, year] = date.split('/');
                  const hours = time?.slice(0, 2) ?? '00';
                  const minutes = time?.slice(3, 5) ?? '00';
                  f['Txn Date'] = `${year}-${month}-${day} ${hours}:${minutes}`;
                }
                if (f['Remarks']) {
                  f['Remarks'] = f['Remarks'].replace('\r\n', ' ');
                }
                f['Debit Amount'] = this.checkNumberFromExcel(f['Debit Amount']);
                f['Credit Amount'] = this.checkNumberFromExcel(f['Credit Amount']);

                return { '#': ++i, ...f };
              });

              let closeBalanceSum = parseFloat(this.openBalance);
              finalJson.forEach((f) => {
                closeBalanceSum = closeBalanceSum - parseFloat(f['Debit Amount']) + parseFloat(f['Credit Amount']);
              });
              this.closeBalance = closeBalanceSum.toFixed(2);
              this.exportedData = finalJson;
              this.selectedFile = files[0];
            }
          } else if (this.selectedTemplate['Template'] == 'Maybank(Transaction)') {
            const sheet = jsonData.find((j) => j['sheet'] == 'Sheet0');

            if (sheet) {
              const sheetData = sheet['data'];
              const keys = Object.keys(sheetData[0]);
              const values = Object.values(sheetData[0]);

              values.forEach((v, i) => {
                const mapped = columnMappingBank.find((c) => c['possibleValues'].includes(v));
                if (mapped) {
                  mapped['key'] = keys[i];
                }
              });

              let finalJson = sheetData.map((s) => {
                const obj = {};
                columnMappingBank.forEach((c) => {
                  obj[c['name']] = s[c['key']] ? s[c['key']] : '';
                });
                return obj;
              });

              finalJson.splice(0, 1);
              finalJson = finalJson.map((f, i) => {
                if (f['Txn Date']) {
                  const [date] = f['Txn Date'].split(' ');
                  // eslint-disable-next-line prefer-const -- month need to be changed so remain as let
                  let [day, month, year] = date.split('/');
                  month = this.getMonthFromString(month);
                  let hours = '';
                  let minutes = '';
                  if (f['Txn Time']) {
                    const [time] = f['Txn Time'].split(' ');
                    hours = time?.slice(0, 2) ?? '00';
                    minutes = time?.slice(3, 5) ?? '00';
                  } else {
                    hours = '00';
                    minutes = '00';
                  }
                  f['Txn Date'] = `${year}-${month}-${day} ${hours}:${minutes}`;
                }
                if (f['Remarks']) {
                  f['Remarks'] = f['Remarks'].replace('\r\n', ' ');
                }
                f['Debit Amount'] = this.checkNumberFromExcel(f['Debit Amount']);
                f['Credit Amount'] = this.checkNumberFromExcel(f['Credit Amount']);

                return { '#': ++i, ...f };
              });

              let closeBalanceSum = parseFloat(this.openBalance);
              finalJson.forEach((f) => {
                closeBalanceSum = closeBalanceSum - parseFloat(f['Debit Amount']) + parseFloat(f['Credit Amount']);
              });
              this.closeBalance = closeBalanceSum.toFixed(2);
              this.exportedData = finalJson;
              this.selectedFile = files[0];
            }
          } else if (this.selectedTemplate['Template'] == 'UOB(Transaction)') {
            const sheet = jsonData.find((j) => j['sheet'] == 'Sheet0');

            if (sheet) {
              const sheetData = sheet['data'];
              const keys = Object.keys(sheetData[1]);
              const values = Object.values(sheetData[1]);

              values.forEach((v, i) => {
                const mapped = columnMappingBank.find((c) => c['possibleValues'].includes(v));
                if (mapped) {
                  mapped['key'] = keys[i];
                }
              });

              let finalJson = sheetData.map((s) => {
                const obj = {};
                columnMappingBank.forEach((c) => {
                  obj[c['name']] = s[c['key']] ? s[c['key']] : '';
                });
                return obj;
              });

              finalJson.splice(0, 2);
              finalJson = finalJson.map((f, i) => {
                if (f['Txn Date']) {
                  const date = f['Txn Date'].trim();
                  const [day, month, year] = date.split('/');
                  let hours = '';
                  let minutes = '';
                  if (f['Txn Time']) {
                    const [time] = f['Txn Time'].trim().split(' ');
                    hours = time?.slice(0, 2) ?? '00';
                    minutes = time?.slice(3, 5) ?? '00';
                  } else {
                    hours = '00';
                    minutes = '00';
                  }
                  f['Txn Date'] = `${year}-${month}-${day} ${hours}:${minutes}`;
                }
                if (f['Remarks']) {
                  f['Remarks'] = f['Remarks'].replace('\r\n', ' ');
                }
                f['Debit Amount'] = this.checkNumberFromExcel(f['Debit Amount']);
                f['Credit Amount'] = this.checkNumberFromExcel(f['Credit Amount']);

                return { '#': ++i, ...f };
              });

              let closeBalanceSum = parseFloat(this.openBalance);
              finalJson.forEach((f) => {
                closeBalanceSum = closeBalanceSum - parseFloat(f['Debit Amount']) + parseFloat(f['Credit Amount']);
              });
              this.closeBalance = closeBalanceSum.toFixed(2);
              this.exportedData = finalJson;
              this.selectedFile = files[0];
            }
          }
        } else {
          this.showMessage('error', 'Please upload excel file with the right format. ');
        }
      } else {
        this.exportedData = [];
        this.selectedFile = null;
      }
    },

    getMonthFromString(mon) {
      const tempM = Date.parse(mon + '1, 2025');
      if (!isNaN(tempM)) {
        return new Date(tempM).getMonth() + 1;
      }
      return -1;
    },

    showMessage: function (type, text) {
      this.messageBoxText = text || ''; //change to coalescing ??
      this.messageBoxType = type || '';
    },

    uploadCancelClick: function () {
      this.showImportBankStatement = false;
      (this.selectedTemplate = null), (this.statementNameUpload = '');
      this.statementDateUpload = null;
      (this.lastMonthClosingBal = null), (this.openBalance = '');
      this.openBalanceError = '';
      this.closeBalance = '';
      this.exportedData = [];
      this.fileDisabled = true;
      this.statementSaveDisabled = true;
      this.showMessage();
    },

    saveStatementList: async function () {
      if (this.validateOpenBalance()) {
        // check if opening balance is a valid number - weishen
        return;
      }
      //check if bankstatementupload already have records. //yes then prompt msg ask user to overwrite or cancel
      let action = 'N';
      if (this.bankStatementData.length > 0) {
        const answer = await this.$showAlert(
          'warning',
          'Validation Check',
          `There is already bank statement uploaded for ${this.selectedStatementName['Statement']}\nDo you want to overwrite the records?`,
          [{ text: 'Overwrite' }, { text: 'Cancel' }],
        );

        if (answer == 'Cancel') {
          return;
        }
        action = 'E';
      }

      //no need to do checking as button only available when all mandatory is filled.
      this.$fullscreenLoading('Uploading Bank Statement');
      const transactionList = [];

      if (this.selectedTemplate['Template'] == 'None') {
        transactionList.push({
          remarks: 'MOCK',
          chequeno: '',
          debitamt: 0,
          creditamt: 0,
          partyname: '',
          recipientref: '',
          paymentdetails: '',
          branchcode: '',
        });
      } else {
        for (const row of this.exportedData) {
          const transaction = {
            transactiondate: row['Txn Date'] ?? '',
            remarks: row['Remarks'] ?? '',
            chequeno:
              row['Cheque No'] ?
                this.possibleNAText.includes(row['Cheque No']) ?
                  ''
                : row['Cheque No']
              : '',
            debitamt: row['Debit Amount'] ? parseFloat(row['Debit Amount']) : 0,
            creditamt: row['Credit Amount'] ? parseFloat(row['Credit Amount']) : 0,
            partyname: row['Party Name'] ?? '',
            recipientref: row['Recipient Reference'] ?? '',
            paymentdetails: row['Payment Details'] ?? '',
            branchcode: row['Branch Code'] ?? '',
          };
          transactionList.push(transaction);
        }
      }
      const totalDebitExported = String(
        parseFloat(
          transactionList
            .map((d) => d['debitamt'])
            .reduce((prev, next) => (prev ?? 0) + (next ?? 0))
            .toFixed(2),
        ),
      );
      const totalCreditExported = String(
        parseFloat(
          transactionList
            .map((c) => c['creditamt'])
            .reduce((prev, next) => (prev ?? 0) + (next ?? 0))
            .toFixed(2),
        ),
      );

      const balanceCFExported = (
        parseFloat(this.openBalance) -
        parseFloat(totalDebitExported) +
        parseFloat(totalCreditExported)
      ).toFixed(2); // 20250102 - weishen
      // let balanceCFExported = (parseFloat(this.openBalance) + parseFloat(totalDebitExported) - parseFloat(totalCreditExported)).toFixed(2);
      const jsonBody = {
        action: action,
        template: this.selectedTemplate['Template'] ?? '',
        statementdate: this.statementDateUpload.formatString('yyyy-MM-dd') ?? '',
        statementname: this.statementNameUpload ?? '',
        bank: this.selectedBank['BankCode'] ?? '',
        openingbalance: this.openBalance ?? '',
        closingbalance: balanceCFExported ?? '',
        branchconfigcode: '',
        statementlist: transactionList,
      };

      const result = await this.$apiCallV2('/BankReconciliation/SaveBankStatementUpload', jsonBody);

      if (result[0]['Results'] == '0') {
        const statementname = this.statementNameUpload;
        this.$showAlert('success', 'Statement Uploaded', `${result[0]['ErrMsg']}`);
        this.uploadCancelClick();
        this.newCancelClick('Cancel');
        this.statementNameList = await this.$apiCallV2('/BankReconciliation/GetBankStatementName', {});
        this.selectedStatementName = this.statementNameList.getSelected(statementname, 'Statement');
        this.statementNameChange(this.selectedStatementName);
        this.$nextTick(() => {
          this.refreshClicked();
        });
      } else {
        this.showMessage('error', result[0]['ErrMsg']);
      }
      this.$fullscreenLoading('');
    },

    checkBranchMonthEnd: async function () {
      if (this.selectedStatementDate) {
        const chkMonthEnd = await this.$apiCallV2('/BankReconciliation/chkMonthEnd', {
          txndate: this.selectedStatementDate?.formatString('yyyy-MM-dd'),
        });
        if (chkMonthEnd) {
          this.companyBranch = this.companyBranch.map((a) => {
            const sameRecord = chkMonthEnd.find(
              (b) => b['BrCoCode'] == a['CoCode'] && b['BrCode'] == a['BrCode'] && b['Dept Code'] == a['DeptCode'],
            );

            if (sameRecord) {
              a['backgroundcolor'] =
                sameRecord['CHIsClose'] == '1' && sameRecord['RTIsClose'] == '1' ? 'lightgreen' : 'red';
              a['tooltiptext'] =
                `Cheque ${sameRecord['CHIsClose'] == '1' ? 'close' : 'not closed'}, Receipt ${sameRecord['RTIsClose'] == '1' ? 'close' : 'not closed'}`;
              a['CHIsClose'] = sameRecord['CHIsClose'];
              a['RTIsClose'] = sameRecord['RTIsClose'];
            } else {
              a['backgroundcolor'] = '';
              a['tooltiptext'] = '';
              a['CHIsClose'] = '';
              a['RTIsClose'] = '';
            }

            return a;
          });
          await this.$nextTick();
        }
      } else {
        this.companyBranch.forEach((a) => {
          a['backgroundcolor'] = '';
          a['tooltiptext'] = '';
        });
      }
      this.blockCompanyBranch = this.companyBranch
        .filter((f) => f['backgroundcolor'] == 'red')
        .map((m) => {
          return m['CoCode'];
        });
    },

    newCancelClick: async function (button) {
      if (this.changesMade && button == 'New') {
        const answer = await this.$showAlert(
          'warning',
          'There are Unsaved Changes',
          'Are you sure you want to clear data?\nAny changes made will not be saved',
          [{ text: 'Clear' }, { text: 'Cancel' }],
        );

        if (answer == 'Cancel') {
          return;
        }
      }

      if (button == 'New') {
        //new
        this.cancelDisabled = false;
        this.newDisabled = true;
        this.statementNameDisabled = true;
        this.changesMade = false;
        this.refreshDisabled = true; // disable Refresh button
        this.statementDateRequired = true; // set [Statement Date] required
        // disable and remove [As At] & [Transaction Within]
        this.asAtRequired = false;
        this.transactionWithinRequired = false;
        this.asAtCheck = false;
        this.transactionWithinCheck = false;
      } else {
        //cancel
        this.cancelDisabled = true;
        this.newDisabled = false;
        this.statementNameDisabled = false;
        this.refreshDisabled = false;
        this.statementDateRequired = false;
        this.asAtRequired = this.asAtCheck;
        this.asAtCheck = false;
        this.transactionWithinCheck = true;
        this.transactionWithinRequired = this.transactionWithinCheck;
      }

      this.selectedBank = null;
      this.bankError = '';
      this.selectedStatementDate = null;
      this.selectedStatementDateError = '';
      this.selectedStatementName = null;
      this.originalStatementName = '';
      this.statementNameError = '';
      this.selectedStatementNameFreeText = '';
      this.selectedTransactionStartDate = null;
      this.transactionStartError = '';
      this.selectedTransactionEndDate = null;
      this.transactionEndError = '';

      this.bankStatementData = [];
      this.bankStatementDataFilter = [];
      this.unreconcileData = [];
      this.reconcileData = [];

      this.balanceBF = '0';
      this.totalDebit = '0';
      this.totalCredit = '0';
      this.balanceCF = '0';
    },

    refreshClicked: async function () {
      let error = false;
      let startdate = '';
      let enddate = '';

      if (this.changesMade) {
        const answer = await this.$showAlert(
          'warning',
          'There are Unsaved Changes',
          'Are you sure you want to refresh?\nAny changes made will not be saved',
          [{ text: 'Refresh' }, { text: 'Cancel' }],
        );

        if (answer == 'Cancel') {
          return;
        }
      }

      //check on compulosry
      if (!this.selectedStatementName && this.selectedStatementNameFreeText == '') {
        this.statementNameError = 'Please select a statement name';
        error = true;
      }
      if (!this.selectedBank) {
        this.bankError = 'Please select a bank';
        error = true;
      }
      if (this.asAtCheck) {
        //As At
        if (!this.selectedAsAtDate) {
          this.asAtError = 'Please select a date';
          error = true;
        } else if (this.selectedAsAtDate > this.smallDateTimeMaxDate) {
          this.asAtError = `Please select date earlier than ${this.smallDateTimeMaxDate.formatString('yyyy-MM-dd')}`;
          error = true;
        } else if (this.selectedAsAtDate < this.smallDateTimeMinValue) {
          this.asAtError = `Please select date later than ${this.smallDateTimeMinValue.formatString('yyyy-MM-dd')}`;
          error = true;
        }

        startdate = '';
        enddate = this.selectedAsAtDate ? this.selectedAsAtDate.formatString('yyyy-MM-dd') : '';
      } else {
        //Transaction Within
        if (!this.selectedTransactionEndDate) {
          this.transactionEndError = 'Please select a date';
          error = true;
        } else if (this.selectedTransactionEndDate && this.selectedTransactionEndDate > this.smallDateTimeMaxDate) {
          this.transactionEndError = `Please select date earlier than ${this.smallDateTimeMaxDate.formatString('yyyy-MM-dd')}`;
          error = true;
        } else if (this.selectedTransactionEndDate && this.selectedTransactionEndDate < this.smallDateTimeMinValue) {
          this.transactionEndError = `Please select date later than ${this.smallDateTimeMinValue.formatString('yyyy-MM-dd')}`;
          error = true;
        }

        if (this.selectedTransactionStartDate && this.selectedTransactionStartDate > this.smallDateTimeMaxDate) {
          this.transactionStartError = `Please select date earlier than ${this.smallDateTimeMaxDate.formatString('yyyy-MM-dd')}`;
          error = true;
        } else if (
          this.selectedTransactionStartDate &&
          this.selectedTransactionStartDate < this.smallDateTimeMinValue
        ) {
          this.transactionStartError = `Please select date later than ${this.smallDateTimeMinValue.formatString('yyyy-MM-dd')}`;
          error = true;
        }

        startdate =
          this.selectedTransactionStartDate ? this.selectedTransactionStartDate.formatString('yyyy-MM-dd') : '';
        enddate = this.selectedTransactionEndDate ? this.selectedTransactionEndDate.formatString('yyyy-MM-dd') : '';
      }

      if (error) {
        return;
      }

      this.$fullscreenLoading('Getting Data');

      this.bankStatementData = [];
      this.bankStatementDataFilter = [];
      this.selectedBankStatement = [];
      this.unreconcileData = [];
      this.selectedUnreconcileData = [];
      this.reconcileData = [];
      this.selectedReconcileData = [];
      this.changesMade = false;
      this.disabledAutoMatch = false;
      await this.$nextTick();

      this.refreshBankCode = JSON.parse(JSON.stringify(this.selectedBank));
      this.refreshStatementDate = new Date(this.selectedStatementDate);
      this.refreshStatementName =
        this.selectedStatementName ? this.selectedStatementName['Statement'] : this.selectedStatementNameFreeText;

      this.bankStatementData = await this.$apiCallV2('/BankReconciliation/GetBankStatementUpload', {
        statementname:
          this.selectedStatementName ? this.selectedStatementName['Statement'] : this.selectedStatementNameFreeText,
      });

      //add sequence number
      let seq = 0;
      this.bankStatementData = this.bankStatementData.map((m) => ({ ...m, Seq: ++seq }));

      if (this.bankStatementData && this.bankStatementData.length > 0) {
        this.balanceBF = String(this.bankStatementData[0]['Opening Bal']);
        this.totalDebit = String(
          parseFloat(
            this.bankStatementData
              .map((d) => d['Debit Amt'])
              .reduce((prev, next) => prev + next)
              .toFixed(2),
          ),
        );
        this.totalCredit = String(
          parseFloat(
            this.bankStatementData
              .map((c) => c['Credit Amt'])
              .reduce((prev, next) => prev + next)
              .toFixed(2),
          ),
        );

        this.balanceCF = String(
          (parseFloat(this.balanceBF) - parseFloat(this.totalDebit) + parseFloat(this.totalCredit)).toFixed(2),
        ); // 20250102 - weishen
        //this.balanceCF = String((parseFloat(this.balanceBF) + parseFloat(this.totalDebit) - parseFloat(this.totalCredit)).toFixed(2));

        //check if bank statment upload without any uploading any excel
        if (this.bankStatementData.some((s) => s['Remarks'] === 'MOCK')) {
          this.disabledAutoMatch = true;
          const bankStatementDataTemp = JSON.parse(JSON.stringify(this.bankStatementData));
          const delIndex = bankStatementDataTemp.indexOf(bankStatementDataTemp.find((f) => f['Remarks'] === 'MOCK'));
          bankStatementDataTemp.splice(delIndex, 1);
          this.bankStatementData = [];
          this.$nextTick(() => (this.bankStatementData = bankStatementDataTemp));
        } else {
          this.bankStatementDataColumn = Object.keys(this.bankStatementData[0])
            .filter((f) => !this.bankStatementHideColumns.includes(f))
            .map((m) => ({
              columnname: m,
            }));
        }
      }

      const jsonData = {
        startdate: startdate,
        enddate: enddate,
        statementname:
          this.selectedStatementName ? this.selectedStatementName['Statement'] : this.selectedStatementNameFreeText,
        bankcode: this.selectedBank['BankCode'],
      };

      let bankReconData = await this.$apiCallV2('/BankReconciliation/GetReconData', jsonData);
      seq = 0;
      bankReconData = bankReconData.map((m) => ({ ...m, Seq: ++seq }));
      this.companyBranch.forEach((f) => {
        bankReconData
          .filter((b) => b['CoCode'] === f['CoCode'])
          .forEach((e) => (e['Branch'] = `${f['Branch Name']}-${f['Department Name']}`));
      });

      this.reconcileData = bankReconData.filter((f) => f['Statement Name'] != '' && f['Statement Name'] != null);
      this.unreconcileData = bankReconData.filter((f) => f['Statement Name'] == '' || f['Statement Name'] == null);

      this.bankStatementData.forEach((f) => {
        f['Original'] = f['MatchTxnID'];
        f['action'] = '';
      });
      this.reconcileData.forEach((f) => {
        f['Original'] = 'R';
        f['action'] = '';
        f['TxnID'] = '';
        f['Temp'] = '';
        f['ParentTxnID'] = '';
        f['Bank Stmt Amt'] = '0'; //bank statement amount
        f['Amount vs Bank Stmt Amt'] = '0'; //diff amount
      });
      this.unreconcileData.forEach((f) => {
        f['Original'] = 'U';
        f['action'] = '';
        f['TxnID'] = '';
        f['ParentTxnID'] = '';
      });

      if (this.unreconcileData && this.unreconcileData.length > 0) {
        this.unreconcileDataColumn = Object.keys(this.unreconcileData[0])
          .filter((f) => !this.unreconcileHideColumns.includes(f))
          .map((m) => ({
            columnname: m,
          }));
      }

      this.reconcileData.forEach((r) => {
        const match = this.bankStatementData.find((f) => f['MatchTxnID'] == r['HeaderTxnID'] && f['matched'] != 'Y');
        if (match) {
          r['TxnID'] = match['TxnID'];
          r['ParentTxnID'] = match['ParentTxnID'];
          if (match['Remarks'] === 'DUPLICATE') {
            r['Temp'] = 'BS';
          } else if (match['Remarks'] === 'REPLICATE') {
            r['Temp'] = 'RP';
          } else {
            r['Temp'] = '';
          }
          r['Bank Stmt Amt'] = match['Debit Amt'] != 0 ? match['Debit Amt'] : -match['Credit Amt'];
          r['Amount vs Bank Stmt Amt'] =
            match['Debit Amt'] != 0 || Math.sign(r['Amount']) === -1 ?
              r['Amount'] - r['Bank Stmt Amt']
            : r['Amount'] + r['Bank Stmt Amt'];
          match['matched'] = 'Y'; //to indicate this bank statement transaction already matched
        }
      });

      //for many to one case start (Additional step for many to one cases)
      this.bankStatementData
        .filter((f) => f['MatchTxnID'] && f['matched'] != 'Y')
        .forEach((e) => {
          if (e['Remarks'] !== 'DUPLICATE') {
            const find = this.reconcileData.find((r) => r['TxnID'] == e['TxnID']);
            if (!find) {
              //if cannot find then need to insert temp record to reconcile table
              // console.log('error frequent here', e['MatchTxnID']);
              const findHeaderIndex = this.reconcileData.findIndex((r) => r['HeaderTxnID'] == e['MatchTxnID']);
              const findHeader = JSON.parse(JSON.stringify(this.reconcileData[findHeaderIndex]));

              findHeader['ParentTxnID'] = e['ParentTxnID']; //previously findHeader['TxnID'] which causes all the bank statement record that have same paranetxnid to be different.
              findHeader['TxnID'] = e['TxnID'];
              findHeader['Temp'] = 'GL';
              findHeader['Bank Stmt Amt'] = e['Debit Amt'] != 0 ? e['Debit Amt'] : -e['Credit Amt']; //change the record with parenttxnid to use other bank statement transaction amount instead of header
              findHeader['Amount vs Bank Stmt Amt'] =
                e['Debit Amt'] != 0 || Math.sign(findHeader['Amount']) === -1 ?
                  findHeader['Amount'] - findHeader['Bank Stmt Amt']
                : findHeader['Amount'] + findHeader['Bank Stmt Amt'];

              this.reconcileData.splice(findHeaderIndex, 0, findHeader); //use splice to add object to after the index
            }
          }
        });
      //for many to one case end

      this.showAllBSCheckClick(this.showAllBSCheck);

      //put selected statement name to originalStatementName to allow checking on statement name changed
      this.originalStatementName = this.selectedStatementName['Statement'];

      this.$fullscreenLoading('');
    },

    outstandingCheckClick: function (state, title) {
      if (state) {
        //true
        if (title == 'As At') {
          this.transactionWithinCheck = false;
          this.asAtRequired = true;
          this.transactionWithinRequired = false;
          this.transactionStartError = '';
          this.transactionEndError = '';
        } else {
          this.asAtCheck = false;
          this.asAtRequired = false;
          this.transactionWithinRequired = true;
        }
      } else {
        // eslint-disable-next-line no-lonely-if -- below is more readable...
        if (title == 'As At') {
          //false
          this.transactionWithinCheck = true;
          this.asAtRequired = false;
          this.transactionWithinRequired = true;
        } else {
          //false
          this.asAtCheck = true;
          this.asAtRequired = true;
          this.transactionWithinRequired = false;
        }
      }
      this.asAtError = '';
      this.transactionStartError = '';
      this.transactionEndError = '';
    },

    autoMatchClick: function () {
      this.selectedBankStatement = [];
      this.selectedUnreconcileData = [];
      this.autoMatchData = [];
      this.selectedAutoMatch = [];
      this.matchSelectedText = 'No matches';
      this.rules1Check = false;
      this.rules1AmountCheck = false;
      this.rules1DateCheck = false;
      this.rules2Check = false;
      this.hideRules2Dropdown = true;
      this.selectedBankStatementDataColumn = null;
      this.selectedBankStatementColumnError = '';
      this.selectedUnreconcilleDataColumn = null;
      this.selectedUnreconcilleColumnError = '';

      if (!this.bankStatementData || this.bankStatementData.length == 0) {
        this.$showAlert('warning', 'No Data To Compare', 'No Bank Statement Uploaded to compare');
        return;
      } else if (!this.unreconcileData || this.unreconcileData.length == 0) {
        this.$showAlert('warning', 'No Data To Compare', 'Please refresh to get records for matching');
        return;
      } else if (
        this.refreshStatementDate.formatString('yyyy-MM-dd') !==
          this.selectedStatementDate.formatString('yyyy-MM-dd') ||
        (this.refreshStatementName !== this.selectedStatementName?.['Statement'] &&
          this.refreshStatementName !== this.selectedStatementNameFreeText)
      ) {
        this.$showAlert(
          'warning',
          'Statement Name or Date is Different',
          `The current data is showing for Bank Statement(${this.refreshStatementName}) dated (${this.refreshStatementDate.formatString('yyyy-MM-dd')})\nCurrent Bank Statement(${this.selectedStatementName ? this.selectedStatementName['Statement'] : this.selectedStatementNameFreeText}) dated (${this.selectedStatementDate.formatString('yyyy-MM-dd')})\nPlease refresh the records again or changed back to current Statement Name`,
        );
        return;
      }
      this.showMatchPopUp = true;
    },

    matchClick: async function () {
      if (!this.rules1Check && !this.rules1AmountCheck && !this.rules1DateCheck && !this.rules2Check) {
        this.$showAlert('warning', 'No Rules Selected', 'Please check one of the rules before matching');
        return;
      }

      if (this.rules2Check) {
        let hasError = false;
        if (!this.selectedBankStatementDataColumn) {
          this.selectedBankStatementColumnError = 'Please select a Bank Statement column name';
          hasError = true;
        }
        if (!this.selectedUnreconcilleDataColumn) {
          this.selectedUnreconcilleColumnError = 'Please select a GL Journal column name';
          hasError = true;
        }
        if (hasError) {
          return;
        }
      }

      this.$fullscreenLoading('Loading');
      await this.$sleep(100);

      this.matchSelectedText = '';
      if (this.rules1Check) {
        this.matchSelectedText += `matching Cheque #`;
      }
      if (this.rules1AmountCheck) {
        this.matchSelectedText += `${this.matchSelectedText ? ' and ' : ''}matching Amount`;
      }
      if (this.rules1DateCheck) {
        this.matchSelectedText += `${this.matchSelectedText ? ' and ' : ''}matching Date`;
      }
      if (this.selectedBankStatementDataColumn && this.selectedUnreconcilleDataColumn) {
        this.matchSelectedText = `matching Bank Statement column "${this.selectedBankStatementDataColumn['columnname']}" VS GL Journal column "${this.selectedUnreconcilleDataColumn['columnname']}"`;
      }
      this.matchSelectedText = `Match with ${this.matchSelectedText}`;

      const copyBankStatementData = JSON.parse(
        JSON.stringify(this.bankStatementData.filter((f) => !f['MatchTxnID'] || f['MatchTxnID'] == '')),
      );
      let copyUnreconcileData = JSON.parse(
        JSON.stringify(this.unreconcileData.filter((f) => !this.blockCompanyBranch.includes(f['CoCode']))),
      );

      this.autoMatchData = [];
      this.selectedAutoMatch = [];
      const autoMatchDataTemp = [];

      if (this.rules1Check || this.rules1AmountCheck || this.rules1DateCheck) {
        //Rules 1 Show me Matching Cheque # and/or Amount and/or Date
        copyUnreconcileData.forEach((u) => {
          let matchRow = null;

          const filters = []; //array to store the functions
          if (this.rules1Check) {
            filters.push((f) => f['Chq #'] == u['Chq #']);
          }
          if (this.rules1AmountCheck) {
            filters.push(
              (f) =>
                (f['Debit Amt'] != 0 && f['Debit Amt'] == u['Amount']) ||
                (f['Credit Amt'] != 0 && -f['Credit Amt'] == u['Amount']),
            );
          }
          if (this.rules1DateCheck) {
            filters.push((f) => f['Txn Date'] == u['Date']);
          }

          matchRow = copyBankStatementData.find((f) => {
            //loop each record
            for (const filter of filters) {
              //loop each filter function
              if (!filter(f)) {
                //if not match either one function then return false
                return false;
              }
            }
            return true; //if all matches return true
          });

          if (matchRow) {
            autoMatchDataTemp.push({
              //combine both bank statement and chequeglpost
              Rules: '1',
              'St Chq #': matchRow['Chq #'],
              'St Txn Date': matchRow['Txn Date'],
              'St Remarks': matchRow['Remarks'],
              'St Debit Amt': matchRow['Debit Amt'],
              'St Credit Amt': matchRow['Credit Amt'],
              'St Party Name': matchRow['Party Name'],
              'St Ref': matchRow['Recipient Ref'],
              'St Det': matchRow['Payment Details'],
              'St TxnId': matchRow['TxnID'],
              'Gl Chq #': u['Chq #'],
              'Gl Date': u['Date'],
              'Gl Type': u['Type'],
              'Gl Txn': u['Txn'],
              'Gl Amount': u['Amount'],
              'Gl Receipt': u['Receipt #'],
              'GL HeaderTxnID': u['HeaderTxnID'],
            });

            const delIndex = copyBankStatementData.indexOf(matchRow);
            copyBankStatementData.splice(delIndex, 1); //delete from bankstatement so wont match again
          }
        });
        //delete all record that already added into the autoMatchData
        const h = autoMatchDataTemp.map((m) => m['GL HeaderTxnID']);
        const filter = copyUnreconcileData.filter((f) => !h.includes(f['HeaderTxnID']));
        copyUnreconcileData = JSON.parse(JSON.stringify(filter));
      }

      if (this.rules2Check) {
        //Rules 2 Show me Matching Left and Right Column
        copyUnreconcileData.forEach((u) => {
          const matchRow = copyBankStatementData.find(
            (f) =>
              (this.selectedBankStatementDataColumn['columnname'] == 'Credit Amt' ?
                -f[this.selectedBankStatementDataColumn['columnname']]
              : f[this.selectedBankStatementDataColumn['columnname']]) ==
              u[this.selectedUnreconcilleDataColumn['columnname']],
          );
          if (matchRow) {
            autoMatchDataTemp.push({
              //combine both bank statement and chequeglpost
              Rules: '2',
              'St Chq #': matchRow['Chq #'],
              'St Txn Date': matchRow['Txn Date'],
              'St Remarks': matchRow['Remarks'],
              'St Debit Amt': matchRow['Debit Amt'],
              'St Credit Amt': matchRow['Credit Amt'],
              'St Party Name': matchRow['Party Name'],
              'St Ref': matchRow['Recipient Ref'],
              'St Det': matchRow['Payment Details'],
              'St TxnId': matchRow['TxnID'],
              'Gl Chq #': u['Chq #'],
              'Gl Date': u['Date'],
              'Gl Type': u['Type'],
              'Gl Txn': u['Txn'],
              'Gl Amount': u['Amount'],
              'Gl Receipt': u['Receipt #'],
              'GL HeaderTxnID': u['HeaderTxnID'],
            });

            const delIndex = copyBankStatementData.indexOf(matchRow);
            copyBankStatementData.splice(delIndex, 1); //delete from bankstatement so wont match again
          }
        });
      }

      this.$nextTick(() => {
        this.autoMatchData = autoMatchDataTemp;
      });

      this.$fullscreenLoading('');
    },

    rules1CheckBoxChange: function (e) {
      if (e && this.rules2Check == true) {
        this.rules2Check = false;
        this.rules2CheckboxChange(false);
      }
    },

    rules2CheckboxChange: function (e) {
      if (e) {
        if (this.rules1Check == true || this.rules1AmountCheck == true || this.rules1DateCheck == true) {
          this.rules1Check = false;
          this.rules1AmountCheck = false;
          this.rules1DateCheck = false;
        }
        this.hideRules2Dropdown = false;
      } else {
        this.hideRules2Dropdown = true;
        this.selectedBankStatementDataColumn = null;
        this.selectedUnreconcilleDataColumn = null;
      }
    },

    reconFunction: async function (a) {
      if (!this.selectedStatementDate || !this.selectedStatementName) {
        this.$showAlert(
          'warning',
          'Statement Name and Date cannot be empty',
          'Please select a statement name and date',
        );
        return;
      } else if (
        this.refreshStatementDate.formatString('yyyy-MM-dd') !==
          this.selectedStatementDate.formatString('yyyy-MM-dd') ||
        (this.refreshStatementName !== this.selectedStatementName?.['Statement'] &&
          this.refreshStatementName !== this.selectedStatementNameFreeText)
      ) {
        this.$showAlert(
          'warning',
          'Statement Name or Date is Different',
          `The current data is showing for Bank Statement(${this.refreshStatementName}) dated (${this.refreshStatementDate.formatString('yyyy-MM-dd')})\nCurrent Bank Statement(${this.selectedStatementName ? this.selectedStatementName['Statement'] : this.selectedStatementNameFreeText}) dated (${this.selectedStatementDate.formatString('yyyy-MM-dd')})\nPlease refresh the records again or changed back to current Statement Name`,
        );
        return;
      }

      if (a == 'RA') {
        //reconcile auto
        //checking first...
        if (!this.selectedAutoMatch || this.selectedAutoMatch.length == 0) {
          this.$showAlert('warning', 'No Record Selected', 'Please select at least 1 record');
          return;
        }

        this.$fullscreenLoading('Loading');
        await this.$sleep(100);

        const reconcileDataTemp = JSON.parse(JSON.stringify(this.reconcileData));
        const unreconcileDataTemp = JSON.parse(JSON.stringify(this.unreconcileData));
        const bankStatementDataTemp = JSON.parse(JSON.stringify(this.bankStatementData));
        this.reconcileData = [];
        this.unreconcileData = [];
        this.bankStatementData = [];

        for (const s of this.selectedAutoMatch) {
          const find = unreconcileDataTemp.find((f) => f['HeaderTxnID'] == s['GL HeaderTxnID']);
          const findEdit = JSON.parse(JSON.stringify(find));
          if (findEdit) {
            findEdit['Statement Name'] = this.selectedStatementName['Statement'];
            findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd');
            findEdit['action'] = find['Original'] == 'R' ? '' : 'R';
            findEdit['TxnID'] = s['St TxnId'];
            findEdit['Temp'] = '';
            findEdit['ParentTxnID'] = '';
            findEdit['Bank Stmt Amt'] = s['St Debit Amt'] != 0 ? s['St Debit Amt'] : -s['St Credit Amt'];
            findEdit['Amount vs Bank Stmt Amt'] = findEdit['Amount'] - findEdit['Bank Stmt Amt'];

            const findBS = bankStatementDataTemp.find((f) => f['TxnID'] == s['St TxnId']);
            findBS['MatchTxnID'] = s['GL HeaderTxnID'];
          }
          reconcileDataTemp.push(findEdit);

          const delIndex = unreconcileDataTemp.indexOf(find);
          unreconcileDataTemp.splice(delIndex, 1);

          this.selectedBankStatement = [];
          this.selectedReconcileData = [];
          this.selectedUnreconcileData = [];

          this.$nextTick(() => {
            this.reconcileData = reconcileDataTemp;
            this.unreconcileData = unreconcileDataTemp;
            this.bankStatementData = bankStatementDataTemp;
            this.showAllBSCheckClick(this.showAllBSCheck);
            this.$fullscreenLoading('');
          });

          if (this.showMatchPopUp == true) {
            this.showMatchPopUp = false;
          }
        }
      } else if (a == 'RM') {
        //reconcile manual
        //checking first...
        if (
          (this.unreconcileData || this.unreconcileData.length > 0) &&
          (!this.selectedUnreconcileData || this.selectedUnreconcileData.length == 0)
        ) {
          this.$showAlert('warning', 'No Unreconciled Record Selected', 'Please select a unreconciled record');
        } else if (
          this.disabledAutoMatch == false &&
          (this.bankStatementData || this.bankStatementData.length > 0) &&
          this.allowReconWithoutBankStatement == '0' &&
          (!this.selectedBankStatement || this.selectedBankStatement.length == 0)
        ) {
          this.$showAlert(
            'warning',
            'No Bank Statement Record Selected',
            'Please select a bank statement to reconcile',
          );
          return;
        }

        if (
          this.selectedUnreconcileData.filter((f) => this.blockCompanyBranch.includes(f['CoCode'])).length >= 1 ||
          this.selectedReconcileData.filter((f) => this.blockCompanyBranch.includes(f['CoCode'])).length >= 1
        ) {
          this.$showAlert('warning', 'Month End Not Close', 'Please only select records that already close month end');
          return;
        }

        this.$fullscreenLoading('Loading');
        await this.$sleep(100);

        const reconcileDataTemp = JSON.parse(JSON.stringify(this.reconcileData));
        const unreconcileDataTemp = JSON.parse(JSON.stringify(this.unreconcileData));
        const bankStatementDataTemp = JSON.parse(JSON.stringify(this.bankStatementData));
        this.reconcileData = [];
        this.unreconcileData = [];
        this.bankStatementData = [];
        this.bankStatementDataFilter = [];
        //different scenario
        if (this.selectedBankStatement.length == 1 && this.selectedUnreconcileData.length == 1) {
          //one to one(OK)...
          const find = unreconcileDataTemp.find(
            (f) => f['HeaderTxnID'] == this.selectedUnreconcileData[0]['HeaderTxnID'],
          );
          const findEdit = JSON.parse(JSON.stringify(find));
          if (findEdit) {
            findEdit['Statement Name'] = this.selectedStatementName['Statement'];
            findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd');
            findEdit['action'] = find['Original'] == 'R' ? '' : 'R';
            findEdit['TxnID'] = this.selectedBankStatement[0]['TxnID'];
            findEdit['Bank Stmt Amt'] =
              this.selectedBankStatement[0]['Debit Amt'] != 0 ?
                this.selectedBankStatement[0]['Debit Amt']
              : -this.selectedBankStatement[0]['Credit Amt'];
            findEdit['Amount vs Bank Stmt Amt'] = findEdit['Amount'] - findEdit['Bank Stmt Amt'];

            const findBS = bankStatementDataTemp.find((f) => f['TxnID'] == this.selectedBankStatement[0]['TxnID']);
            findBS['MatchTxnID'] = find['HeaderTxnID'];
          }
          reconcileDataTemp.push(findEdit);

          const delIndex = unreconcileDataTemp.indexOf(find);
          unreconcileDataTemp.splice(delIndex, 1);
        } else if (this.selectedBankStatement.length == 1 && this.selectedUnreconcileData.length > 1) {
          //one to many
          const findBS = bankStatementDataTemp.find((f) => f['TxnID'] == this.selectedBankStatement[0]['TxnID']);
          findBS['MatchTxnID'] = this.selectedUnreconcileData[0]['HeaderTxnID'];

          for (const s of this.selectedUnreconcileData) {
            const find = unreconcileDataTemp.find((f) => f['HeaderTxnID'] == s['HeaderTxnID']);
            const findEdit = JSON.parse(JSON.stringify(find));
            if (findEdit) {
              findEdit['Statement Name'] = this.selectedStatementName['Statement'];
              findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd');
              findEdit['action'] = find['Original'] == 'R' ? '' : 'R';
              findEdit['TxnID'] = this.selectedBankStatement[0]['TxnID'];
              findEdit['ParentTxnID'] = this.selectedBankStatement[0]['TxnID'];
              findEdit['Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
              findEdit['Amount vs Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
              findEdit['Temp'] = findEdit['HeaderTxnID'] === this.selectedUnreconcileData[0]['HeaderTxnID'] ? '' : 'BS';
            }
            reconcileDataTemp.push(findEdit);

            const delIndex = unreconcileDataTemp.indexOf(find);
            unreconcileDataTemp.splice(delIndex, 1);

            if (s['HeaderTxnID'] !== this.selectedUnreconcileData[0]['HeaderTxnID']) {
              const newBSTemp = JSON.parse(JSON.stringify(findBS));
              newBSTemp['TxnID'] = '';
              newBSTemp['MatchTxnID'] = s['HeaderTxnID'];
              bankStatementDataTemp.push(newBSTemp);
            }
          }
        } else if (this.selectedBankStatement.length > 1 && this.selectedUnreconcileData.length == 1) {
          //many to one(OK)
          const find = unreconcileDataTemp.find(
            (f) => f['HeaderTxnID'] == this.selectedUnreconcileData[0]['HeaderTxnID'],
          );
          const findEdit = JSON.parse(JSON.stringify(find));
          if (findEdit) {
            findEdit['Statement Name'] = this.selectedStatementName['Statement'];
            findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd');
            findEdit['action'] = find['Original'] == 'R' ? '' : 'R';
            findEdit['TxnID'] = this.selectedBankStatement[0]['TxnID'];
            findEdit['Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
            findEdit['Amount vs Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
            findEdit['Temp'] = '';
          }
          reconcileDataTemp.push(findEdit);

          const delIndex = unreconcileDataTemp.indexOf(find);
          unreconcileDataTemp.splice(delIndex, 1);

          for (const s of this.selectedBankStatement) {
            if (s['TxnID'] != this.selectedBankStatement[0]['TxnID']) {
              //the first selectedBankStatement already push to reconcileDataTemp so continue to next
              const newTemp = JSON.parse(JSON.stringify(findEdit));
              newTemp['TxnID'] = s['TxnID'];
              newTemp['Temp'] = 'GL'; //indicate create temp at GL
              newTemp['ParentTxnID'] = this.selectedBankStatement[0]['TxnID'];
              newTemp['Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
              newTemp['Amount vs Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
              reconcileDataTemp.push(newTemp);
            }

            const findBS = bankStatementDataTemp.find((f) => f['TxnID'] == s['TxnID']);
            findBS['MatchTxnID'] = find['HeaderTxnID'];
          }
        } else if (this.selectedBankStatement.length > 1 && this.selectedUnreconcileData.length > 1) {
          //many to many
          const count = Math.max(this.selectedBankStatement.length, this.selectedUnreconcileData.length);

          const findBS = bankStatementDataTemp.find((f) => f['TxnID'] == this.selectedBankStatement[0]['TxnID']); //BS header object
          const findGL = unreconcileDataTemp.find(
            (f) => f['HeaderTxnID'] == this.selectedUnreconcileData[0]['HeaderTxnID'],
          ); //GL unreconcile header oject

          for (let i = 0; i < count; i++) {
            let findEdit = null;
            const BSTemp = this.selectedBankStatement[i]; //the current object of the bank statement for i index
            const GLTemp = this.selectedUnreconcileData[i]; //the current object of the cheque gl for i index

            if (BSTemp && GLTemp) {
              //bs and gl both have object
              const find = unreconcileDataTemp.find((f) => f['HeaderTxnID'] == GLTemp['HeaderTxnID']);
              findEdit = JSON.parse(JSON.stringify(find));
              if (findEdit) {
                findEdit['Statement Name'] = this.selectedStatementName['Statement'];
                findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd');
                findEdit['action'] = find['Original'] == 'R' ? '' : 'R';
                findEdit['TxnID'] = BSTemp['TxnID'];
                findEdit['ParentTxnID'] =
                  BSTemp['TxnID'] !== this.selectedBankStatement[0]['TxnID'] ?
                    this.selectedBankStatement[0]['TxnID']
                  : '';
                findEdit['Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
                findEdit['Amount vs Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
                const findBS = bankStatementDataTemp.find((f) => f['TxnID'] == BSTemp['TxnID']);
                findBS['MatchTxnID'] = find['HeaderTxnID'];
              }

              const delIndex = unreconcileDataTemp.indexOf(find);
              unreconcileDataTemp.splice(delIndex, 1);
            } else if (!BSTemp && GLTemp) {
              //bs empty and gl have object
              const find = unreconcileDataTemp.find((f) => f['HeaderTxnID'] == GLTemp['HeaderTxnID']);
              findEdit = JSON.parse(JSON.stringify(find));
              if (findEdit) {
                findEdit['Statement Name'] = this.selectedStatementName['Statement'];
                findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd');
                findEdit['action'] = find['Original'] == 'R' ? '' : 'R';
                findEdit['TxnID'] = this.selectedBankStatement[0]['TxnID'];
                findEdit['ParentTxnID'] = this.selectedBankStatement[0]['TxnID'];
                findEdit['Temp'] = 'BS';
                findEdit['Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
                findEdit['Amount vs Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1

                if (GLTemp['HeaderTxnID'] !== this.selectedUnreconcileData[0]['HeaderTxnID']) {
                  const newBSTemp = JSON.parse(JSON.stringify(findBS));
                  newBSTemp['TxnID'] = '';
                  newBSTemp['MatchTxnID'] = GLTemp['HeaderTxnID'];
                  bankStatementDataTemp.push(newBSTemp);
                }
              }

              const delIndex = unreconcileDataTemp.indexOf(find);
              unreconcileDataTemp.splice(delIndex, 1);
            } else if (BSTemp && !GLTemp) {
              //bs have object and gl empty
              findEdit = JSON.parse(JSON.stringify(findGL));
              if (findEdit) {
                findEdit['Statement Name'] = this.selectedStatementName['Statement'];
                findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd');
                findEdit['action'] = findGL['Original'] == 'R' ? '' : 'R';
                findEdit['TxnID'] = BSTemp['TxnID'];
                findEdit['ParentTxnID'] =
                  BSTemp['TxnID'] !== this.selectedBankStatement[0]['TxnID'] ?
                    this.selectedBankStatement[0]['TxnID']
                  : '';
                findEdit['Temp'] = 'GL';
                findEdit['Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
                findEdit['Amount vs Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1

                const findBS = bankStatementDataTemp.find((f) => f['TxnID'] == BSTemp['TxnID']);
                findBS['MatchTxnID'] = findGL['HeaderTxnID'];
              }
            }

            reconcileDataTemp.push(findEdit);
          }
        } else if (this.selectedBankStatement.length == 0 && this.selectedUnreconcileData.length > 0) {
          //no bank statement uploaded - reconcile
          this.selectedUnreconcileData.forEach((unr) => {
            const find = unreconcileDataTemp.find((f) => f['HeaderTxnID'] == unr['HeaderTxnID']); //find the record in the actual unreconcile table
            const findEdit = JSON.parse(JSON.stringify(find)); //put inside a new variable
            if (findEdit) {
              findEdit['Statement Name'] = this.selectedStatementName['Statement']; //put in the statement name
              findEdit['Statement Date'] = this.selectedStatementDate.formatString('yyyy-MM-dd'); //put in the statement date
              findEdit['action'] = find['Original'] == 'R' ? '' : 'R'; //put in the action but check the original first, if ori is R already then no action else put R
              findEdit['TxnID'] = find['HeaderTxnID']; //re-use headertxnid for BS(insert to bank statement table)
              findEdit['Temp'] = 'RP'; //replicate
              findEdit['Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
              findEdit['Amount vs Bank Stmt Amt'] = 'NA'; //set to NA which will show as 0 because not 1 to 1
            }
            reconcileDataTemp.push(findEdit);
            const delIndex = unreconcileDataTemp.indexOf(find);
            unreconcileDataTemp.splice(delIndex, 1);
          });
        }

        this.selectedBankStatement = [];
        this.selectedReconcileData = [];
        this.selectedUnreconcileData = [];

        this.$nextTick(() => {
          this.reconcileData = reconcileDataTemp;
          this.unreconcileData = unreconcileDataTemp;
          this.bankStatementData = bankStatementDataTemp;
          this.showAllBSCheckClick(this.showAllBSCheck);
          this.$fullscreenLoading('');
        });
      } else if (a == 'U') {
        //unreconcile
        //checking first...
        if (!this.selectedReconcileData || this.selectedReconcileData.length == 0) {
          this.$showAlert('warning', 'No Reconciled Record Selected', 'Please select a reconciled record');
          return;
        }
        this.$fullscreenLoading('Loading');
        await this.$sleep(100);

        const reconcileDataTemp = JSON.parse(JSON.stringify(this.reconcileData));
        const unreconcileDataTemp = JSON.parse(JSON.stringify(this.unreconcileData));
        const bankStatementDataTemp = JSON.parse(JSON.stringify(this.bankStatementData));
        this.reconcileData = [];
        this.unreconcileData = [];
        this.bankStatementData = [];

        //auto select any records that is related to the selected reconcile data. //same parenttxnid or headertxnid
        const setTxnID = new Set(); //use set to have distinct
        this.selectedReconcileData.forEach((f) => {
          setTxnID.add(f['ParentTxnID'] ? f['ParentTxnID'] : f['TxnID']);
        });

        const tempSelectedReconcileData = structuredClone(
          reconcileDataTemp.filter((f, _i) => {
            const returnValue = setTxnID.has(f['TxnID']) || setTxnID.has(f['ParentTxnID']);
            return returnValue;
          }),
        );

        for (const s of tempSelectedReconcileData) {
          const find = reconcileDataTemp.find((f) => f['HeaderTxnID'] == s['HeaderTxnID']);
          const findEdit = JSON.parse(JSON.stringify(find));
          if (findEdit) {
            findEdit['Statement Name'] = '';
            findEdit['Statement Date'] = '';
            findEdit['action'] = find['Original'] == 'U' ? '' : 'U';
            findEdit['TxnID'] = find['Original'] == 'U' ? '' : s['TxnID'];
            let findBS = bankStatementDataTemp.find((f) => f['TxnID'] == s['TxnID']);

            if (findEdit['Temp'] == 'BS' || findEdit['Temp'] == 'RP') {
              findBS = bankStatementDataTemp.find((f) => f['MatchTxnID'] == s['HeaderTxnID']);
            }
            if (
              findBS &&
              (findBS['TxnID'] == '' || findBS['Remarks'] == 'DUPLICATE' || findBS['Remarks'] == 'REPLICATE')
            ) {
              const delIndex = bankStatementDataTemp.indexOf(findBS);
              bankStatementDataTemp.splice(delIndex, 1);
            } else if (findBS) {
              findBS['MatchTxnID'] = '';
              findBS['action'] = 'U';
            }
          }
          if (!unreconcileDataTemp.find((f) => f['HeaderTxnID'] == findEdit['HeaderTxnID'])) {
            unreconcileDataTemp.push(findEdit);
          }

          const delIndex = reconcileDataTemp.indexOf(find);
          reconcileDataTemp.splice(delIndex, 1);
        }

        this.selectedBankStatement = [];
        this.selectedReconcileData = [];
        this.selectedUnreconcileData = [];

        this.$nextTick(() => {
          this.reconcileData = reconcileDataTemp;
          this.unreconcileData = unreconcileDataTemp;
          this.bankStatementData = bankStatementDataTemp;
          this.showAllBSCheckClick(this.showAllBSCheck);
          this.$fullscreenLoading('');
        });
      }

      this.changesMade = true;
    },

    saveClick: async function () {
      if (this.changesMade == false) {
        await this.$showAlert('warning', 'No Changes Made', 'Please reconcile or unreconciled records to save');
        return;
      }
      if (this.selectedStatementName['Statement'] != this.originalStatementName) {
        await this.$showAlert('warning', 'Statement Name Changed', `Current data is showing Statement(${this.originalStatementName}) records. Please switch back to the previous statement name or refresh the data again`);
        return;
      }

      this.$fullscreenLoading('Loading'); //refreshclicked loading will remove later on...

      let branch = [];
      let distinctCoCode = [];
      let sendRecords = [];

      const unreconFind = this.unreconcileData.filter((f) => f['action'] != '' && f['action']);

      //for many to one case start
      this.bankStatementData
        .filter((f) => f['action'] == 'U')
        .forEach((e) => {
          //check if action U in bank statement then loop each record
          const check = unreconFind.find((u) => u['TxnID'] == e['TxnID']); //find bank statement txnid in unrecon table
          if (!check) {
            //if not exists
            const duplicate = unreconFind.find((u) => e['Original'] == u['HeaderTxnID']); //find the unrecon record with the same txnid
            if (duplicate) {
              //if found
              const duplicateEdit = JSON.parse(JSON.stringify(duplicate)); //copy to new object and change the txnid that not exist in the unrecon table
              duplicateEdit['TxnID'] = e['TxnID'];
              unreconFind.push(duplicateEdit);
            }
          }
        });
      //for many to one case end

      sendRecords = sendRecords.concat(unreconFind);
      const reconFind = this.reconcileData.filter((f) => f['action'] != '' && f['action']);
      sendRecords = sendRecords.concat(reconFind);
      distinctCoCode = [...new Set(sendRecords.map((i) => i.CoCode))];

      distinctCoCode.forEach((c) => {
        const branchRecords = sendRecords.filter((f) => f['CoCode'] == c);
        const reconciliationarr = branchRecords.map((i) => {
          return {
            headertxnid: i['HeaderTxnID'],
            txnid: i['TxnID'],
            parenttxnid: i['ParentTxnID'],
            action: i['action'],
            temp: i['Temp'],
          };
        });

        const findBranch = this.companyBranch.find((f) => f['CoCode'] === c);

        const branchTemp = {
          brcocode: c,
          branchname: `${findBranch['Branch Name']}-${findBranch['Department Name']}`,
          reconciliationarr: reconciliationarr,
        };

        branch = branch.concat(branchTemp);
      });
      if (branch.length == 0) {
        this.changesMade = false;
        this.$showAlert('warning', 'No Changes Made', 'Please reconcile or unreconcilled records to save');
        this.$fullscreenLoading(''); //here did not hit refreshclicked so have to remove here
        return;
      }

      const jsonBody = {
        statementname: this.selectedStatementName['Statement'],
        statementdate: this.selectedStatementDate.formatString('yyyy-MM-dd'),
        branch: branch,
      };

      const result = await this.$apiCallV2('/BankReconciliation/SaveReconciliationData', jsonBody);
      if (result[0]['Results'] == '0') {
        this.$showAlert('success', 'Bank Reconciliation Saved', `${result[0]['ErrMsg']}`);
        this.changesMade = false;
        this.refreshClicked();
      } else {
        this.$showAlert(
          'error',
          'Error Saving Bank Reconciliation',
          'There is an error occur when saving bank reconciliation.\nPlease try to save again',
        );
      }
    },

    showAllBSCheckClick: function (state) {
      this.bankStatementDataFilter = [];

      if (state) {
        this.$nextTick(() => (this.bankStatementDataFilter = this.bankStatementData));
      } else {
        this.$nextTick(
          () =>
            (this.bankStatementDataFilter = this.bankStatementData.filter(
              (f) => f['MatchTxnID'] == '' || !f['MatchTxnID'],
            )),
        );
      }
    },

    reconcileRowSelected: function (data, selected) {
      //data is the selected data
      //selected is if the data is select or unselect
      const temp = JSON.parse(JSON.stringify(this.selectedReconcileData));
      this.showReconcileData = false;
      this.selectedReconcileData = [];

      if (selected) {
        const TxnID = data['ParentTxnID'] && data['ParentTxnID'] != '' ? data['ParentTxnID'] : data['TxnID'];
        const allSelect = this.reconcileData.filter((f) => f['TxnID'] == TxnID || f['ParentTxnID'] == TxnID);

        const index = temp.indexOf(data);
        temp.splice(index, 1);
        this.$nextTick(() => {
          this.selectedReconcileData = temp.concat(allSelect);
        });
      } else {
        const TxnID = data['ParentTxnID'] && data['ParentTxnID'] != '' ? data['ParentTxnID'] : data['TxnID'];
        const allDeselect = temp.filter((f) => f['TxnID'] == TxnID || f['ParentTxnID'] == TxnID);
        allDeselect.forEach((d) => {
          const index = temp.indexOf(d);
          temp.splice(index, 1);
        });
        this.$nextTick(() => {
          this.selectedReconcileData = temp;
        });
      }

      this.$nextTick(() => {
        this.showReconcileData = true;
      });
    },

    validateOpenBalance: function () {
      this.showMessage();
      let result = false;
      this.openBalanceError = '';
      const value = this.openBalance;
      if (value != '') {
        if (!/^[-+]?[0-9]*\.?[0-9]+$/.test(value)) {
          this.openBalanceError = 'Please enter a valid number';
          result = true;
        } else {
          this.openBalanceError = '';
          result = false;
        }
      }

      if (result == false && this.lastMonthClosingBal != null && this.lastMonthClosingBal != value) {
        //compare with last month closing balance
        this.showMessage(
          'error',
          `Opening Balance does not match last month closing balance(${this.currencyFormattedValue('lastMonthClosingBal')}). `,
        );
        result = true;
      }

      return result;
    },

    errorColumnCheck: function () {
      if (this.rules2Check && !this.selectedBankStatementDataColumn && !this.selectedUnreconcilleDataColumn) {
        if (!this.selectedBankStatementDataColumn) {
          this.selectedBankStatementColumnError = 'Please select a column';
          return true;
        }

        if (!this.selectedUnreconcilleDataColumn) {
          this.selectedUnreconcilleColumnError = 'Please select a column';
          return true;
        }
        return false;
      }
    },
    currencyFormattedValue: function (field) {
      return this.$currencyFormat(this[field]);
    },
    printClicked: async function () {
      if (!this.selectedStatementName && this.selectedStatementNameFreeText == '') {
        this.$showAlert('warning', 'No Statement Selected', 'Please select a statement name');
        return;
      }
      if (this.changesMade) {
        const answer = await this.$showAlert(
          'warning',
          'There are Unsaved Changes',
          'Are you sure you want to print?\nUnsaved changes will not be included.',
          [{ text: 'Yes' }, { text: 'No', color: 'lightgray' }],
        );

        if (answer == 'No') {
          return;
        }
      }
      const route = this.$router.resolve(
        `/Home/${this.$route.params['user']}/FINAccount/Print%20Bank%20Reconciliation?statement=${this.selectedStatementName.Statement}&date=${this.selectedStatementName['Statement Date']}&bank=${this.selectedStatementName.Bank}`,
      );
      window.open(route.href, '_blank');
    },
    checkNumberFromExcel: function (value) {
      let returnValue = '';
      if (value && !isNaN(value.replace(',','')) && value.trim() !== '') {
        returnValue = value.replace(' ', '').replace(',', '');
      } else {
        returnValue = '0.00';
      }
      return returnValue;
    },
  },
  async mounted() {
    this.$fullscreenLoading('Getting Data');

    this.loginDetails = await this.$apiCallV2('/Login/GetDetails');

    const banklist = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BANK' });
    banklist.forEach((f) => {
      f['banknamecurrency'] = `${f['BankName']} (${f['BankCurrency'] ? f['BankCurrency'] : 'N/A'})`;
    });
    this.bankList = banklist;

    this.statementNameList = await this.$apiCallV2('/BankReconciliation/GetBankStatementName', {});

    this.companyBranch = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PARENTCOMPANYBRANCH' });
    this.companyBranch.forEach((f) => {
      f['tooltiptext'] = 'no data';
      f['branchdepartment'] = `${f['BrCode']}-${f['DeptCode']}`;
    });

    if (this.reconciliationList.length == 1) {
      this.selectedReconType = this.reconciliationList[0];
    }

    this.allowReconWithoutBankStatement = (
      await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=6GBankReconNoBSRecon')
    )[0].SettingsValue;

    this.selectedAsAtDate = new Date();

    this.$fullscreenLoading('');
  },
  watch: {
    selectedBank: function (val) {
      if (val) {
        this.statementDateDisabled = false;
      } else {
        this.bankDescription = '';
        this.bankCurrency = '';
        this.statementDateDisabled = true;
        this.selectedStatementDate = null;
        this.selectedStatementDateError = '';
      }
    },

    selectedStatementDate: function (val) {
      if (val) {
        if (val > this.smallDateTimeMaxDate) {
          this.selectedStatementDateError = `Please select date earlier than ${this.smallDateTimeMaxDate.formatString('yyyy-MM-dd')}`;
          this.$nextTick(() => (this.selectedStatementDate = null));
          return;
        } else if (val < this.smallDateTimeMinValue) {
          this.selectedStatementDateError = `Please select date later than ${this.smallDateTimeMinValue.formatString('yyyy-MM-dd')}`;
          this.$nextTick(() => (this.selectedStatementDate = null));
          return;
        }

        this.checkBranchMonthEnd();

        //default trsanction within date based on statement date. (Get first and last day of sattement month)
        const statementYear = val.getFullYear();
        const statementMonth = val.getMonth();
        this.selectedTransactionStartDate = new Date(statementYear, statementMonth, 1);
        this.selectedTransactionEndDate = new Date(statementYear, statementMonth + 1, 0);
      } else {
        this.companyBranch.forEach((f) => {
          f['backgroundcolor'] = '';
          f['tooltiptext'] = 'no data';
        });
      }

      if (val && this.selectedBank) {
        if (this.newDisabled == true) {
          //if user click on New button
          this.selectedStatementName = null;

          //create new statement name based on statement date and bank
          //convention Bank Code + '_' + yyyymmdd + '_' + CoCode
          const newStatementName = `${this.selectedBank['BankCode']}_${val.formatString('yyyyMMdd')}_${this.loginDetails['CoCode']}`;
          const match = `${this.selectedBank['BankCode']}_${val.formatString('yyyyMM')}`;
          const find = this.statementNameList.find((f) => f['Statement'].includes(match));
          if (find) {
            this.selectedStatementNameFreeText = '';
            this.$showAlert(
              'error',
              'Statement Name existed',
              `Statement(${find['Statement']}) already created for this month. Please exit new mode or use different statement month`,
            );
          } else {
            this.selectedStatementNameFreeText = newStatementName;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.bank-recon-main {
  font-size: 12px;
  padding: 10px 10px 10px 45px;
  display: flex;
  height: 100%;

  > .left-container {
    border-radius: 5px;
    max-width: 250px;
    min-width: 250px;
    width: 100%;
    background-color: white;
    margin-right: 5px;
    height: 100%;
    z-index: 12;

    > .left-arrow-button {
      width: 100%;
      padding: 7px 4px 10px 0px;
      display: flex;
      justify-content: flex-end;

      > img {
        height: 30px;
        width: 30px;
        padding: 2px;
        z-index: 1;
        transition: 0.3s;
        cursor: pointer;
      }
    }

    > .left-container-content {
      padding-left: 5px;
      padding-right: 5px;
      display: flex;
      flex-direction: column;

      > .left-container-content-det {
        margin-top: 5px;
      }

      > .left-container-content-button {
        margin-top: 5px;
        width: 100%;
        display: flex;
        flex-direction: row;

        button {
          margin: 5px;
          width: 100%;
        }
      }

      > .left-container-content-refresh {
        margin-top: 5px;
        width: 100%;
        padding: 5px;

        button {
          width: 100%;
        }
      }

      .BC-MonthEnd {
        > .BC-Branch {
          text-align: center;
          display: flex;
          margin-top: 5px;
          padding: 3px;
          border-radius: 5px;
          border: 1px solid black;

          > .BC-Branch-Name {
            width: 90%;
          }

          > .BC-Branch-Tooltip {
            width: 10%;

            > .BC-tooltipText {
              cursor: pointer;
              z-index: 9;
              justify-content: flex-end;
            }
          }
        }
      }
    }
  }

  > .right-container {
    height: 100%;
    width: calc(100% - 255px);

    > .right-body {
      border-radius: 5px;
      background-color: white;
      display: flex;
      flex-direction: column;
      height: calc(100% - 45px);
      overflow: auto;

      > .right-body-top {
        min-height: 70%;
        width: 100%;
        display: flex;
        flex-direction: row;

        > .right-body-left {
          width: calc(50% - 15px);
          height: 100%;
          padding: 5px;

          > .right-body-left-button {
            display: flex;
            justify-content: flex-end;
            height: 25px;
            width: 100%;
          }

          > .right-body-left-table {
            width: 100%;
            height: calc(100% - 25px);
          }
        }

        > .right-body-middle {
          height: 100%;
          width: 30px;
          display: flex;
          align-items: flex-end;
        }

        > .right-body-right {
          height: 100%;
          width: calc(50% - 15px);
          padding: 5px;

          > .right-body-right-button {
            display: flex;
            justify-content: flex-end;
            height: 25px;
            width: 100%;
          }

          > .right-body-right-table {
            width: 100%;
            height: calc(100% - 25px);
          }
        }
      }

      > .right-body-bottom {
        display: flex;
        flex-direction: column;
        min-height: 70%;
        width: 100%;

        > .right-bottom-arrow-button {
          display: flex;
          justify-content: flex-end;

          > img {
            height: 30px;
            width: 30px;
            padding: 2px;
            z-index: 1;
            transition: 0.3s;
            cursor: pointer;
          }
        }

        > .right-bottom-table {
          padding: 5px;
          width: 100%;
          height: 100%;
        }
      }
    }

    > .right-bottom {
      border-radius: 5px;
      height: 40px;
      background-color: white;
      margin-top: 5px;
      padding: 5px;
      display: flex;
      flex-direction: row;
      width: 100%;

      > .right-bottom-content {
        display: flex;
        flex-direction: row;
        width: 90%;
        justify-content: space-between;
        margin-top: 5px;

        > :not(:first-child) {
          margin-left: 5px;
        }
      }

      > .right-bottom-button {
        width: 10%;
        display: flex;
        justify-content: right;

        img {
          height: 20px;
        }
      }
    }
  }

  > .left-tab-close {
    max-width: 40px;
    min-width: 40px;
  }

  > .right-tab-full {
    width: calc(100% - 45px);
  }
}

.bank-recon-upload {
  font-size: 12px;
  padding: 10px 10px 10px 45px;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  background-color: grey;
  z-index: 100;

  > .top-container {
    border-radius: 5px;
    background-color: white;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 120px;
    padding: 5px;

    > .top-container-content {
      display: flex;
      align-items: flex-start;

      > :not(:first-child) {
        margin-left: 5px;
      }
    }

    > .top-container-file {
      display: flex;
      flex-direction: row;

      > .file-input {
        width: 30%;
      }

      > .file-button {
        width: 10%;
        display: flex;
        justify-content: flex-end;

        > button {
          height: 30px;
          width: 60px;
          white-space: nowrap;
          margin-right: 5px;
        }
      }

      > .message-container {
        width: 60%;
        max-height: 80px;
        min-height: 80px;
        overflow: auto;
        padding: 5px;
      }
    }
  }

  > .body {
    border-radius: 5px;
    background-color: white;
    height: calc(100% - 120px);
    padding: 5px;
    margin-top: 5px;
  }
}

.bank-recon-match {
  font-size: 12px;
  padding: 10px 10px 10px 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1500;

  > .bank-recon-match-container {
    height: calc(100% - 10px);
    width: calc(100% - 20px);
    padding: 10px;
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 5px;

    > .top-container {
      height: 80px;
      width: 100%;
      display: flex;
      flex-direction: row;
      border: 1px solid black;
      border-radius: 5px;
      padding: 3px;

      > .top-container-checkbox {
        width: 45%;

        > .checkbox-one {
          display: flex;
          flex-direction: row;
        }

        > .top-container-dropdown {
          display: flex;
          flex-direction: row;
          margin-top: 10px;
          gap: 5px;
        }
      }

      > .top-container-button {
        width: 5%;
        margin: auto;
        display: flex;
        justify-content: flex-end;
        padding: 5px;
      }

      > .top-container-match-text {
        width: 20%;
        border-left: 1px solid black;
        padding-left: 3px;
      }

      > .top-container-info {
        width: 30%;
        border-left: 1px solid black;
        padding-left: 3px;
      }
    }

    > .body {
      height: calc(100% - 60px - 40px);
      width: 100%;
    }

    > .bottom-container {
      height: 40px;

      > .bottom-container-button {
        display: flex;
        justify-content: flex-end;
        padding: 5px;

        :first-child {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
